var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesGbe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 410 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke-width: .1px;\n      }\n\n      .st1, .st2, .st3 {\n        stroke-linecap: round;\n      }\n\n      .st1, .st2, .st3, .st6 {\n        stroke: #0f2c4d;\n      }\n\n      .st1, .st4, .st5, .st6 {\n        stroke-miterlimit: 10;\n      }\n\n      .st7 {\n        fill: #99c0e2;\n      }\n\n      .st2 {\n        stroke-width: .2px;\n      }\n\n      .st2, .st3 {\n        stroke-linejoin: round;\n      }\n\n      .st3 {\n        stroke-width: .4px;\n      }\n\n      .st8 {\n        fill: #fff;\n      }\n\n      .st4, .st5 {\n        stroke: #99c0e2;\n      }\n\n      .st5 {\n        stroke-width: 1.1px;\n      }\n\n      .st6 {\n        stroke-width: .5px;\n      }\n\n      .st6, .st9 {\n        fill: #0f2c4d;\n      }\n\n      .st10 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.6,
    cy: 46.1,
    r: 26.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.9,15.6l1,8.6h-1.3c-1.5-6.4-6.6-9.9-14.4-9.9s-17,9.2-17,19.4,6.5,21.1,17.5,21.1,5.9-.7,8.2-2.4v-9.2c0-3.7-1.7-4.4-4.6-4.4h-1v-1.6c3.4,0,5.9,0,8,0,3.6,0,6.5,0,7.9,0v1.6h-.6c-3,0-3.7,1.7-3.7,4.6v7.9l.9.9v1c-4.9,1.8-10.5,3.5-15.9,3.5-17.3,0-23.5-13.6-23.5-22.2,0-12.7,9.8-22.3,22.7-22.3s10.6,1.4,15.7,3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M143.7,13.2c2.9,0,3.8.1,6.2.1,4.5,0,5.9-.1,8.6-.1,7.5,0,14.4,2.8,14.4,9.9s-3.5,8.2-9.8,9.7h0c4.6,0,13.7,3,13.7,11.4s-5.2,11.6-16.6,11.6-6,0-9.1,0-4.9,0-7.3,0v-1.6c4.3.2,5.6-1.7,5.6-4v-31.1c0-3.7-1.7-4.3-5.6-4.3v-1.6h0ZM155.3,32.5h2.4c6.8,0,9.2-3.5,9.2-9.3s-2.2-8.1-8.8-8.1-2,0-2.8.1v17.2h0ZM155.3,49.1c0,2.8.3,4.8,5.5,4.8s9.7-4.5,9.7-8.8c0-7.1-3.7-10.6-11.3-10.6h-3.8v14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.5,13.2c3.8.1,10.9.1,16.4.1s10.4,0,13.5-.1v9.1l-1.2.3c-.9-5.6-3.7-7.5-9.5-7.5h-7.4v17.4h8.2c3.1,0,4.8-1.6,5-5.3h1.2c-.1,1.4-.2,3.9-.2,6.9s.3,4.9.2,6.7h-1.2c0-5.1-1.3-5.9-5.5-5.9h-7.7v10.9c0,6.5.5,7.9,6.5,7.9h3.5c2.3,0,3.5-.2,4.5-.4,2.7-.7,4.8-2.1,6.7-7.3l1.5.2c-1,3.1-1.8,5.9-2.5,9.3-5.8,0-11.7,0-17.5,0s-9.6,0-14.4,0v-1.6c5,0,5.8-.7,5.8-6.5v-27.7c0-4.5-.8-5.1-5.8-5.3v-1.6h0v.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.5,14.2l.4,3.5h-.6c-.6-2.6-2.7-4-5.9-4s-7,3.7-7,7.9,2.6,8.6,7.1,8.6,2.4-.3,3.4-1v-3.7c0-1.5-.7-1.8-1.9-1.8h-.4v-.6h6.5v.6h-.2c-1.2,0-1.5.7-1.5,1.9v3.2l.4.4v.4c-2,.7-4.3,1.4-6.5,1.4-7.1,0-9.6-5.5-9.6-9.1,0-5.2,4-9.1,9.3-9.1s4.3.6,6.4,1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M258.2,23.2v.4l-.2.2h-7v1.4c.2,2.3,1.6,4.3,3.7,4.3s2.5-.8,3.4-1.7l.4.4c-1.4,1.9-2.9,2.8-4.6,2.8-3.7,0-4.8-3.4-4.8-5.5,0-4.9,3.3-6.3,5-6.3s4.2,1.5,4.2,4h0ZM255.3,23c.5,0,.7-.2.7-.6,0-1.2-.7-2.3-2.2-2.3s-2.5,1.1-2.8,2.9h4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M263.7,19.5v1.6c1.4-1,2.6-1.9,4.3-1.9s2.9,1.4,2.9,3.5v6.5c0,.5.2.8,1,.8h.7v.6h-5.4v-.6h.6c.6,0,1,0,1-.8v-6.5c0-1.3-.7-2.1-2.3-2.1s-2,.6-2.9,1.2v7.4c0,.7.3.8,1,.8h.7v.6h-5.3v-.6h.6c.7,0,1-.2,1-.8v-6.7c0-.9-.4-1.2-1.4-1.6v-.5l1.6-.5c.5-.2,1.1-.4,1.7-.7,0,0,.2,0,.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M286.3,25.1c0,3.1-2.4,5.9-5.7,5.9s-6-2.4-6-5.8,2.4-5.9,5.7-5.9,6.1,2.4,6.1,5.8h-.1ZM280.6,30.4c2.4,0,3.5-2.7,3.5-5s-1.1-5.4-3.8-5.4-3.4,2.5-3.4,5,1.2,5.4,3.7,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.9,19.5v1.6c2-1.5,3.1-1.9,4.3-1.9s2.3.6,2.6,1.9c1.8-1.3,2.8-1.9,4.3-1.9s3,1.5,3,3.5v6.5c0,.6.3.8,1,.8h.6v.6h-5.2v-.6h.6c.7,0,1-.2,1-.8v-5.6c0-2.1-.7-3-2.2-3s-1.9.5-2.9,1.2v7.4c0,.5.3.8,1,.8h.7v.6h-5.3v-.6h.7c.6,0,1-.2,1-.8v-5.6c0-2.1-.7-3-2.2-3s-1.9.5-2.9,1.2v7.3c0,.6.2.9,1,.9h.6v.6h-5.4v-.6h.7c.5,0,1,0,1-.8v-6.9c0-.9-.2-1.2-1.3-1.7v-.4c1.6-.5,2.4-.8,2.6-.9.2,0,.4-.2.5-.2s.2.2.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.7,23.2v.4l-.2.2h-7v1.4c.2,2.3,1.6,4.3,3.7,4.3s2.5-.8,3.4-1.7l.4.4c-1.4,1.9-2.9,2.8-4.6,2.8-3.7,0-4.8-3.4-4.8-5.5,0-4.9,3.3-6.3,5-6.3s4.2,1.5,4.2,4h-.1ZM315.9,23c.5,0,.7-.2.7-.6,0-1.2-.7-2.3-2.2-2.3s-2.5,1.1-2.8,2.9h4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M328,13.2h6c3.1,0,5.9,1.1,5.9,4s-1.4,3.3-4,4h0c1.9,0,5.6,1.2,5.6,4.7s-2.1,4.7-6.8,4.7-2.5,0-3.7,0h-3v-.6c1.8,0,2.3-.7,2.3-1.6v-12.7c0-1.5-.7-1.8-2.3-1.8v-.6h0ZM332.7,21.1h1c2.8,0,3.7-1.4,3.7-3.8s-.9-3.3-3.6-3.3-.8,0-1.1,0v7h0ZM332.7,27.9c0,1.1.1,1.9,2.2,1.9s3.9-1.8,3.9-3.6c0-2.9-1.5-4.3-4.6-4.3h-1.6v6h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M347.1,19.5v9.6c0,.7.2.9,1.2.9h.5v.6h-5.4v-.6h.5c.7,0,1.2,0,1.2-.8v-6.8c0-1-.3-1.2-1.3-1.8v-.4c1.7-.5,2.3-.7,2.6-.9.2-.1.3-.2.5-.2s.2.2.2.3h0ZM347.3,14.2c0,.7-.6,1.2-1.2,1.2s-1.2-.6-1.2-1.2.6-1.2,1.2-1.2,1.2.6,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362.6,25.1c0,3.1-2.4,5.9-5.7,5.9s-6-2.4-6-5.8,2.4-5.9,5.7-5.9,6.1,2.4,6.1,5.8h-.1ZM356.9,30.4c2.4,0,3.5-2.7,3.5-5s-1.1-5.4-3.8-5.4-3.4,2.5-3.4,5,1.2,5.4,3.7,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.4,11.9v17.3c0,.6.3.8,1,.8h.7v.6h-5.3v-.6h.6c.6,0,1.1,0,1.1-.8v-13.8c0-1.5-.1-1.8-1.3-2.1v-.4c1.4-.5,2.2-.8,2.6-1.1.4-.2.4-.3.6-.3s.2.1.2.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.9,25.1c0,3.1-2.4,5.9-5.7,5.9s-6-2.4-6-5.8,2.4-5.9,5.7-5.9,6.1,2.4,6.1,5.8h-.1ZM378.2,30.4c2.4,0,3.5-2.7,3.5-5s-1.1-5.4-3.8-5.4-3.4,2.5-3.4,5,1.2,5.4,3.7,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M395.5,20c.2,0,.9,0,1.6-.1v1.2h-2.5c.4.4.6,1.1.6,1.8,0,2-1.8,3.8-4.5,3.8s-1,0-1.4-.2c-.5.4-.7.7-.7,1.3s.6,1.1,1.7,1.1h3.5c2,0,3.3.6,3.3,2.5s-1.2,4.8-6.6,4.8-4.7-1.2-4.7-2.8,1-2.4,2.9-2.9h0c-1.2-.4-2.2-1.1-2.2-2.2s0-.5,0-.8c.9-.5,1.8-1,2.1-1.2-1.4-.7-2.3-1.7-2.3-3.3s1.8-3.8,4.7-3.8,2.9.8,4.5.8ZM390.9,35.5c1.9,0,4.4-.8,4.4-2.9s-1.7-2-3.7-2-4,.3-4,2.3,1.2,2.5,3.3,2.5h0ZM390.8,26.1c1.5,0,2.4-1.1,2.4-2.9s-.8-3.3-2.6-3.3-2.2,1.4-2.2,2.8.7,3.3,2.3,3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M398.4,19.6h5.1v.6c-1.2,0-1.4.3-1.4.7,0,.7,2,5.2,2.5,6.7h0s.4-1.1,1.2-3c.8-1.9,1.2-3,1.2-3.3,0-.6-.3-1-1.2-1h-.2v-.6h4.2v.6c-1.2,0-1.6.9-2,1.7l-5.6,13.1c-.4.9-.9,1.2-1.6,1.2s-1.2-.5-1.2-1.2.5-1.2,1.2-1.2.6,0,1,.4c.8-1.7,1-2.3,1.7-4-2-5.1-3.1-8.1-3.5-8.8-.3-.7-.7-1.2-1.7-1.1v-.6h0l.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238,46.4v6.9c0,.9.3,1.4.9,1.4s.7-.2.9-.4l.2.4c-.7.6-1.5,1.3-2.5,1.3s-1.5-.9-1.5-1.8c-1.1,1-2.2,1.8-3.8,1.8s-2.7-1.1-2.7-2.4c0-2,1.3-2.4,6.5-4.2v-1.6c0-1.3-.7-2.1-2.4-2.1s-1.9.8-1.9,1.8-.9,1-1.4,1-.4-.3-.4-.5c0-1.4,1.3-2,3-2.9.9-.4,1.2-.7,2.1-.7s3,.8,3,2.1h0ZM233.2,54.9c1.2,0,1.9-.7,2.7-1.4v-3.3c-.1,0-.7.2-1.4.5-1.7.6-3.1,1.2-3.1,2.5s.8,1.8,1.8,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.4,44.6v1.6c1.4-1,2.6-1.9,4.3-1.9s2.9,1.4,2.9,3.5v6.5c0,.5.2.8,1,.8h.7v.6h-5.4v-.6h.6c.6,0,1,0,1-.8v-6.5c0-1.3-.7-2.1-2.3-2.1s-2,.6-2.9,1.2v7.4c0,.7.3.8,1,.8h.7v.6h-5.3v-.6h.6c.7,0,1-.2,1-.8v-6.7c0-.9-.4-1.2-1.4-1.6v-.5l1.6-.5c.5-.2,1.1-.4,1.7-.7,0,0,.2,0,.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.8,37v16.6c0,.9.2,1,1,1h.6v.5c-1.3.3-3.1,1-3.4,1s-.3-.2-.3-.6v-1.2h0c-.9,1-2.4,1.8-3.8,1.8-2.8,0-4.6-2.4-4.6-5.4s2.8-6.4,6.2-6.4,1.6.2,2.3.4v-4.4c0-1.4-.2-1.7-1.3-1.9v-.4c1.3-.4,2.1-.8,2.6-1.1.3-.2.4-.3.6-.3s.2.2.2.3h-.1ZM262.4,54.6c.9,0,2.4-.6,2.4-1.4v-5.8c0-1.4-1-2.2-2.7-2.2s-3.7,1.3-3.7,4.7,1.6,4.8,3.9,4.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M277.3,38.3h12.2v3.7h-.5c-.4-2.2-1.5-2.9-3.9-2.9h-3v7.1h3.3c1.2,0,2-.6,2-2.1h.5v2.8c0,1.2.1,2,0,2.7h-.5c0-2.1-.6-2.4-2.2-2.4h-3.1v4.5c0,2.7.2,3.2,2.7,3.2h1.4c.9,0,1.4,0,1.8-.2,1.1-.3,2-.9,2.7-3h.6c-.4,1.4-.7,2.5-1,3.9h-13v-.6c2,0,2.4-.3,2.4-2.6v-11.3c0-1.8-.3-2.1-2.4-2.1v-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292.5,44.7h5.1v.6c-1.3,0-1.4.2-1.4.7s0,.5.2.9c.8,2,1.5,4.1,2.3,6.2l2.1-5.1c.2-.4.5-1.3.5-2s-.1-.5-1.3-.6v-.6h4v.6c-1,0-1.4.3-2,1.8l-3.6,9h-.6l-3.3-8.7c-.7-1.8-.9-2-1.8-2h-.2v-.6h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.6,50.2c0,3.1-2.4,5.9-5.7,5.9s-6-2.4-6-5.8,2.4-5.9,5.7-5.9,6.1,2.4,6.1,5.8h-.1ZM311.8,55.5c2.4,0,3.5-2.7,3.5-5s-1.1-5.4-3.8-5.4-3.4,2.5-3.4,5,1.2,5.4,3.7,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M323.3,37v17.3c0,.6.3.8,1,.8h.7v.6h-5.3v-.6h.6c.6,0,1.1,0,1.1-.8v-13.8c0-1.5-.1-1.8-1.3-2.1v-.4c1.4-.5,2.2-.8,2.6-1.1.4-.2.4-.3.6-.3s.2,0,.2.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M330.4,45.3v6.6c0,1.8.7,2.8,2.1,2.8s2-.6,3-1.5v-6.7c0-.4-.5-.6-2.1-1v-.4c2.6-.2,3.5-.4,3.9-.4s.2.2.2.3v9.3c0,.3,0,.5.6.5h1v.5c-1.2.2-2.4.4-3.6.8h-.1v-2.1c-1.4,1.2-2.6,2.1-4.4,2.1s-2.7-1.1-2.7-2.9v-6.5c0-.9-.5-1.2-1.5-1.3v-.5c.9,0,2.1,0,3.1-.2.4,0,.4,0,.4.6h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.3,42.2v2.5h3.7v1.3h-3.7v6.7c0,1.3.7,2,1.6,2s1.2-.2,1.7-.7l.4.4c-.9.9-2,1.7-3.3,1.7s-2.4-1-2.4-2.3v-7.8h-1.6v-.4c1.7-1.2,2.3-1.9,3.3-3.5h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M353.2,44.6v9.6c0,.7.2.9,1.2.9h.5v.6h-5.4v-.6h.5c.7,0,1.2,0,1.2-.8v-6.8c0-1-.3-1.2-1.3-1.8v-.4c1.7-.5,2.3-.7,2.6-.9.2,0,.3-.2.5-.2s.2.2.2.3h0ZM353.4,39.2c0,.7-.6,1.2-1.2,1.2s-1.2-.6-1.2-1.2.6-1.2,1.2-1.2,1.2.6,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.7,50.2c0,3.1-2.4,5.9-5.7,5.9s-6-2.4-6-5.8,2.4-5.9,5.7-5.9,6.1,2.4,6.1,5.8h-.1ZM363,55.5c2.4,0,3.5-2.7,3.5-5s-1.1-5.4-3.8-5.4-3.4,2.5-3.4,5,1.2,5.4,3.7,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374.4,44.6v1.6c1.4-1,2.6-1.9,4.3-1.9s2.9,1.4,2.9,3.5v6.5c0,.5.2.8,1,.8h.7v.6h-5.4v-.6h.6c.6,0,1,0,1-.8v-6.5c0-1.3-.7-2.1-2.3-2.1s-2,.6-2.9,1.2v7.4c0,.7.3.8,1,.8h.7v.6h-5.3v-.6h.6c.7,0,1-.2,1-.8v-6.7c0-.9-.4-1.2-1.4-1.6v-.5l1.6-.5c.5-.2,1.1-.4,1.7-.7,0,0,.2,0,.2.2h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 220.8,
    y1: 10.2,
    x2: 220.8,
    y2: 58.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M108.8,76.7l-1-2.5h-3.2l-1,2.5h-.9l3.1-7.9h.8l3.1,7.9h-1,0ZM107.5,73.4l-.9-2.4c0-.3-.2-.7-.4-1.1,0,.3-.2.7-.3,1.1l-.9,2.4h2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.9,79.4c-.3,0-.6,0-.8,0v-.7c.2,0,.5,0,.7,0s.5,0,.6-.2.2-.4.2-.7v-6.9h.9v6.8c0,1.2-.5,1.8-1.6,1.8h0ZM113.5,69.2c0-.2,0-.4.2-.5s.2,0,.4,0,.3,0,.4,0,.2.2.2.4,0,.4-.2.5-.2,0-.4,0-.3,0-.4,0-.2-.2-.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M121.5,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h0ZM117,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.9,70.8v3.8c0,.5,0,.8.3,1.1s.6.4,1,.4,1.1-.2,1.4-.5.4-.9.4-1.7v-3.1h.9v5.9h-.7v-.8h-.2c-.2.3-.4.5-.8.7s-.7.2-1.1.2c-.7,0-1.3-.2-1.6-.5s-.5-.9-.5-1.6v-3.9h.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M132.6,70.7h.7v.8h-.8c-.5,0-.9.2-1.2.6s-.5.9-.5,1.5v3.2h-.9v-5.9h.7v1.1h.1c.2-.4.5-.7.8-.9s.7-.3,1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M138.4,76.7v-3.8c0-.5-.1-.8-.3-1.1s-.6-.4-1-.4-1.1.2-1.4.5-.4.9-.4,1.7v3.1h-.9v-5.9h.7v.8h.2c.2-.3.4-.5.8-.7s.7-.2,1.1-.2c.7,0,1.3.2,1.6.5s.5.9.5,1.7v3.9h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.8,76.7l-.2-.8h0c-.3.4-.6.6-.9.8s-.7.2-1.1.2-1-.2-1.4-.5-.5-.7-.5-1.3c0-1.2,1-1.8,2.9-1.9h1v-.4c0-.5-.1-.8-.3-1s-.5-.3-1-.3-1.1.2-1.7.5l-.3-.7c.3-.2.6-.3,1-.4s.7,0,1,0c.7,0,1.2.2,1.6.5s.5.8.5,1.5v4h-.7,0ZM142.8,76.1c.6,0,1-.2,1.3-.5s.5-.7.5-1.3v-.5h-.9c-.7,0-1.2.2-1.5.4s-.5.5-.5.9,0,.6.3.7.5.3.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.2,76.7h-.9v-8.4h.9v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M158.1,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8c.5.6.7,1.3.7,2.2h-.1ZM153.6,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M162.3,71.5h-1.5v5.2h-.9v-5.2h-1.1v-.4l1.1-.3v-.3c0-1.5.6-2.2,1.9-2.2s.7,0,1.1.2l-.2.7c-.3,0-.6-.2-.9-.2s-.6,0-.7.3-.2.6-.2,1.1v.4h1.5v.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M168.2,76.1h.9v.7s-.2,0-.4,0-.4,0-.5,0c-1.1,0-1.7-.6-1.7-1.8v-3.5h-.8v-.4l.8-.4.4-1.3h.5v1.4h1.7v.7h-1.7v3.5c0,.4,0,.6.3.8s.4.3.7.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M174.3,76.7v-3.8c0-.5-.1-.8-.3-1.1s-.6-.4-1-.4-1.1.2-1.4.5-.4.9-.4,1.7v3.1h-.9v-8.4h.9v3.3h0c.2-.3.4-.5.8-.7s.7-.2,1.1-.2c.7,0,1.3.2,1.6.5s.5.9.5,1.6v3.9h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.5,76.9c-.9,0-1.6-.3-2.1-.8s-.8-1.3-.8-2.2.2-1.7.7-2.3,1.1-.8,1.9-.8,1.3.2,1.8.7.6,1.1.6,1.9v.6h-4.1c0,.7.2,1.2.5,1.6s.8.5,1.4.5,1.3,0,1.9-.4v.8c-.3,0-.6.2-.9.3s-.6,0-1,0h.1ZM179.3,71.5c-.5,0-.9.2-1.1.5s-.4.7-.5,1.3h3.1c0-.6-.1-1-.4-1.3s-.6-.5-1.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M190.7,74.6c0,.7-.3,1.2-.8,1.6s-1.2.6-2.1.6-1.7,0-2.2-.4v-.9c.3,0,.7.2,1.1.3s.8,0,1.1,0c.6,0,1.1,0,1.4-.3s.5-.6.5-1,0-.5-.2-.7-.3-.3-.6-.5-.6-.3-1.2-.5c-.7-.3-1.3-.6-1.6-.9s-.5-.8-.5-1.4.2-1.1.7-1.5,1.1-.5,1.8-.5,1.5,0,2.2.4l-.3.8c-.7-.3-1.3-.4-1.9-.4s-.9,0-1.1.3-.4.5-.4.9,0,.5.2.7l.5.5c.2.2.6.3,1.1.5.8.3,1.4.6,1.7.9s.5.8.5,1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M197.3,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM192.8,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.2,76.9c-.9,0-1.5-.3-2-.8s-.7-1.3-.7-2.2.2-1.8.7-2.3,1.2-.8,2-.8h.9c.3,0,.5,0,.7.2l-.3.8c-.2,0-.4,0-.6-.2s-.4,0-.6,0c-1.2,0-1.8.8-1.8,2.3s.1,1.3.4,1.7.7.6,1.3.6,1,0,1.5-.3v.8c-.4.2-.9.3-1.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M204,69.2c0-.2,0-.4.2-.5s.2,0,.4,0,.3,0,.4,0,.2.2.2.4,0,.4-.2.5-.2,0-.4,0-.3,0-.4,0-.2-.2-.2-.5h0ZM205,76.7h-.9v-5.9h.9v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M209.4,76.9c-.9,0-1.6-.3-2.1-.8s-.8-1.3-.8-2.2.2-1.7.7-2.3,1.1-.8,1.9-.8,1.3.2,1.8.7.6,1.1.6,1.9v.6h-4.1c0,.7.2,1.2.5,1.6s.8.5,1.4.5,1.3,0,1.9-.4v.8c-.3,0-.6.2-.9.3s-.6,0-1,0h.1ZM209.2,71.5c-.5,0-.9.2-1.1.5s-.4.7-.5,1.3h3.1c0-.6-.1-1-.4-1.3s-.6-.5-1.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M215,76.1h.9v.7s-.2,0-.4,0-.4,0-.5,0c-1.1,0-1.7-.6-1.7-1.8v-3.5h-.8v-.4l.8-.4.4-1.3h.5v1.4h1.7v.7h-1.7v3.5c0,.4,0,.6.3.8s.4.3.7.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M216.1,70.8h1l1.3,3.4c.3.8.5,1.3.5,1.7h0c0-.2.1-.5.3-.9s.6-1.8,1.5-4.1h1l-2.5,6.7c-.3.7-.5,1.1-.9,1.4s-.7.4-1.2.4h-.8v-.7h.7c.6,0,1.1-.3,1.3-1l.3-.8-2.4-6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M228.1,71.5h-1.5v5.2h-.9v-5.2h-1.1v-.4l1.1-.3v-.3c0-1.5.6-2.2,1.9-2.2s.7,0,1.1.2l-.2.7c-.3,0-.6-.2-.9-.2s-.6,0-.7.3-.2.6-.2,1.1v.4h1.5v.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.3,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM229.8,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.6,70.7h.7v.8h-.8c-.5,0-.9.2-1.2.6s-.5.9-.5,1.5v3.2h-.9v-5.9h.7v1.1h.1c.2-.4.5-.7.8-.9s.7-.3,1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.9,76.7l-2.7-7h0v7h-.8v-7.9h1.4l2.5,6.5h0l2.5-6.5h1.4v7.9h-.9v-7h0l-2.7,7h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258.4,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM253.9,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.9,76.7h-.9v-8.4h.9v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M265.3,76.9c-.9,0-1.6-.3-2.1-.8s-.8-1.3-.8-2.2.2-1.7.7-2.3,1.1-.8,1.9-.8,1.3.2,1.8.7.6,1.1.6,1.9v.6h-4.1c0,.7.2,1.2.5,1.6s.8.5,1.4.5,1.3,0,1.9-.4v.8c-.3,0-.6.2-.9.3s-.6,0-1,0h.1ZM265,71.5c-.5,0-.9.2-1.1.5s-.4.7-.5,1.3h3.1c0-.6-.1-1-.4-1.3s-.6-.5-1.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M271.3,76.9c-.9,0-1.5-.3-2-.8s-.7-1.3-.7-2.2.2-1.8.7-2.3,1.2-.8,2-.8h.9c.3,0,.5,0,.7.2l-.3.8c-.2,0-.4,0-.6-.2s-.4,0-.6,0c-1.2,0-1.8.8-1.8,2.3s.1,1.3.4,1.7.7.6,1.3.6,1,0,1.5-.3v.8c-.4.2-.9.3-1.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.1,70.8v3.8c0,.5.1.8.3,1.1s.6.4,1,.4,1.1-.2,1.4-.5.4-.9.4-1.7v-3.1h.9v5.9h-.7v-.8h-.2c-.2.3-.4.5-.8.7s-.7.2-1.1.2c-.7,0-1.3-.2-1.6-.5s-.5-.9-.5-1.6v-3.9h.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M281.9,76.7h-.9v-8.4h.9v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M287.5,76.7l-.2-.8h0c-.3.4-.6.6-.9.8s-.7.2-1.1.2-1-.2-1.4-.5-.5-.7-.5-1.3c0-1.2,1-1.8,2.9-1.9h1v-.4c0-.5-.1-.8-.3-1s-.5-.3-1-.3-1.1.2-1.7.5l-.3-.7c.3-.2.6-.3,1-.4s.7,0,1,0c.7,0,1.2.2,1.6.5s.5.8.5,1.5v4h-.7.1ZM285.4,76.1c.6,0,1-.2,1.3-.5s.5-.7.5-1.3v-.5h-.9c-.7,0-1.2.2-1.5.4s-.5.5-.5.9,0,.6.3.7.5.3.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M292.7,70.7h.7v.8h-.8c-.5,0-.9.2-1.2.6s-.5.9-.5,1.5v3.2h-.9v-5.9h.7v1.1h.1c.2-.4.5-.7.8-.9s.7-.3,1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M297.5,68.8h2.2c1,0,1.8.2,2.3.5s.7.8.7,1.5-.1.9-.4,1.2-.6.5-1.1.6h0c1.2.3,1.8.9,1.8,1.9s-.2,1.3-.7,1.7-1.1.6-2,.6h-2.8v-7.9h0ZM298.4,72.2h1.5c.6,0,1.1,0,1.4-.3s.4-.5.4-1-.2-.8-.5-1-.8-.3-1.5-.3h-1.3v2.6h0ZM298.4,73v3h1.6c.6,0,1.1,0,1.4-.4s.5-.6.5-1.2-.2-.9-.5-1.1-.8-.3-1.5-.3h-1.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M304.5,69.2c0-.2,0-.4.2-.5s.2,0,.4,0,.3,0,.4,0,.2.2.2.4,0,.4-.2.5-.2,0-.4,0-.3,0-.4,0-.2-.2-.2-.5h0ZM305.4,76.7h-.9v-5.9h.9v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M312.5,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM307.9,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.9,76.7h-.9v-8.4h.9v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M321.9,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM317.4,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M328.4,70.8v.6h-1.1c.1.3.2.4.3.6s.1.4.1.7c0,.6-.2,1-.6,1.4s-.9.5-1.6.5-.3,0-.5,0c-.4.2-.6.5-.6.8s0,.3.2.4.4,0,.7,0h1c.6,0,1.1,0,1.5.4s.5.7.5,1.2-.3,1.2-.8,1.5-1.3.5-2.3.5-1.4,0-1.8-.4-.6-.7-.6-1.2.1-.7.3-.9.6-.4,1-.5c-.2,0-.3-.2-.4-.3s-.2-.3-.2-.5,0-.4.2-.6.3-.3.5-.5c-.3,0-.6-.3-.7-.6s-.3-.6-.3-1c0-.6.2-1.1.6-1.5s.9-.5,1.7-.5.6,0,.8,0h2.1v-.3ZM323.6,77.7c0,.3.1.6.4.7s.7.2,1.2.2c.8,0,1.3,0,1.7-.3s.5-.5.5-.9,0-.5-.3-.7-.6-.2-1.1-.2h-1.1c-.4,0-.7,0-.9.3s-.3.5-.3.8h-.1ZM324.1,72.7c0,.4.1.7.4.9s.6.3,1,.3c.9,0,1.3-.4,1.3-1.3s-.4-1.3-1.3-1.3-.7,0-1,.3-.3.6-.3,1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M328.6,70.8h1l1.3,3.4c.3.8.5,1.3.5,1.7h0c0-.2.1-.5.3-.9s.6-1.8,1.5-4.1h1l-2.5,6.7c-.3.7-.5,1.1-.9,1.4s-.7.4-1.2.4h-.8v-.7h.7c.6,0,1.1-.3,1.3-1l.3-.8-2.4-6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M341.7,76.7l-.2-.8h0c-.3.4-.6.6-.9.8s-.7.2-1.1.2-1-.2-1.4-.5-.5-.7-.5-1.3c0-1.2,1-1.8,2.9-1.9h1v-.4c0-.5-.1-.8-.3-1s-.5-.3-1-.3-1.1.2-1.7.5l-.3-.7c.3-.2.6-.3,1-.4s.7,0,1,0c.7,0,1.2.2,1.6.5s.5.8.5,1.5v4h-.7.1ZM339.6,76.1c.6,0,1-.2,1.3-.5s.5-.7.5-1.3v-.5h-.9c-.7,0-1.2.2-1.5.4s-.5.5-.5.9,0,.6.3.7.5.3.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M348.2,76.7v-3.8c0-.5-.1-.8-.3-1.1s-.6-.4-1-.4-1.1.2-1.4.5-.4.9-.4,1.7v3.1h-.9v-5.9h.7v.8h.2c.2-.3.4-.5.8-.7s.7-.2,1.1-.2c.7,0,1.3.2,1.6.5s.5.9.5,1.7v3.9h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M355,75.9h0c-.4.6-1,.9-1.9.9s-1.4-.3-1.8-.8-.6-1.3-.6-2.3.2-1.7.6-2.3,1-.8,1.8-.8,1.4.3,1.8.9h0v-3.2h.9v8.4h-.7v-.8h-.1,0ZM353.2,76.1c.6,0,1.1-.2,1.3-.5s.4-.9.4-1.6v-.2c0-.8-.1-1.4-.4-1.8s-.7-.5-1.3-.5-.9.2-1.2.6-.4,1-.4,1.7.1,1.3.4,1.7.7.6,1.2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M365.2,76.7h-4.4v-7.9h4.4v.8h-3.5v2.5h3.3v.8h-3.3v2.9h3.5v.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M368.1,76.7l-2.2-5.9h1l1.3,3.5c.3.8.5,1.4.5,1.6h0c0-.2.2-.6.4-1.2s.7-1.9,1.4-3.9h1l-2.2,5.9h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.4,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM372.9,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M379.9,76.7h-.9v-8.4h.9v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M382.6,70.8v3.8c0,.5.1.8.3,1.1s.6.4,1,.4,1.1-.2,1.4-.5.4-.9.4-1.7v-3.1h.9v5.9h-.7v-.8h-.2c-.2.3-.4.5-.8.7s-.7.2-1.1.2c-.7,0-1.3-.2-1.6-.5s-.5-.9-.5-1.6v-3.9h.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M390.5,76.1h.9v.7s-.2,0-.4,0-.4,0-.5,0c-1.1,0-1.7-.6-1.7-1.8v-3.5h-.8v-.4l.8-.4.4-1.3h.5v1.4h1.7v.7h-1.7v3.5c0,.4,0,.6.3.8s.4.3.7.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M392.4,69.2c0-.2,0-.4.2-.5s.2,0,.4,0,.3,0,.4,0,.2.2.2.4,0,.4-.2.5-.2,0-.4,0-.3,0-.4,0-.2-.2-.2-.5h0ZM393.4,76.7h-.9v-5.9h.9v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M400.4,73.8c0,1-.2,1.7-.7,2.3s-1.2.8-2,.8-1,0-1.4-.4-.7-.6-.9-1.1-.3-1-.3-1.6c0-1,.2-1.7.7-2.3s1.2-.8,2-.8,1.5.3,2,.8.7,1.3.7,2.2h-.1ZM395.9,73.8c0,.8.2,1.3.5,1.7s.7.6,1.3.6,1-.2,1.3-.6.5-1,.5-1.7-.2-1.3-.5-1.7-.8-.6-1.3-.6-1,.2-1.3.6-.4,1-.4,1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M406,76.7v-3.8c0-.5-.1-.8-.3-1.1s-.6-.4-1-.4-1.1.2-1.4.5-.4.9-.4,1.7v3.1h-.9v-5.9h.7v.8h.2c.2-.3.4-.5.8-.7s.7-.2,1.1-.2c.7,0,1.3.2,1.6.5s.5.9.5,1.7v3.9h-.9Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 45.4,
    cy: 46.1,
    r: 36.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 58.3,
    cy: 81.3,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 32.6,
    cy: 81.2,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 13,
    cy: 64.7,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 8.7,
    cy: 39.4,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 21.5,
    cy: 17.3,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 45.6,
    cy: 8.7,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 69.6,
    cy: 17.5,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 82.4,
    cy: 39.7,
    r: 8.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 77.8,
    cy: 64.9,
    r: 8.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 45.8,
    cy: 45.6,
    r: 27.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.2,14c-5,16.1-4.5,35.7,17.2,35,5.3-.2,10.6-1.3,15.6-2.8-5.1,1.5-10.3,2.7-15.6,2.8-21.7.7-22.3-19-17.2-35.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.7,14c-2.9,9-5.3,22.9,2.1,30.3,7.7,7.4,21.2,4.2,30.4,1.5-9.2,2.7-22.6,5.9-30.4-1.4-7.4-7.5-5-21.3-2-30.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.2,14c-3.3,9.9-6.3,26.6,4.9,32.5,8.2,4,18.8,1.3,27.1-1.3-8.3,2.5-18.9,5.3-27.2,1.3-11.2-5.9-8.2-22.7-4.9-32.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.7,14c-3.4,9.8-6.7,26.7,4.6,32.5,8.2,3.9,18.8.9,27.1-1.7-8.2,2.6-18.9,5.6-27.1,1.7-11.3-5.8-7.9-22.8-4.5-32.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.2,14c-3.5,9.6-7.1,26.8,4.2,32.4,8.2,3.7,18.9.6,27-2-8.1,2.7-18.9,5.8-27.1,2.1-11.4-5.6-7.7-22.8-4.2-32.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.6,14c-3.5,9.4-7.6,26.8,3.8,32.3,8,3.6,19,.3,27-2.4-8,2.7-18.9,6-27,2.5-11.5-5.4-7.3-22.9-3.8-32.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.1,14c-3.2,8.3-7,23,.2,30,7.3,6.9,21.8,2.3,30.2-.7-8.4,3-22.8,7.6-30.2.7-7.2-7.1-3.4-21.8-.2-30.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.6,14c-3.2,8.2-7.4,23-.2,30,7.4,6.8,21.8,1.9,30.2-1.1-7.9,2.9-18.7,6.5-26.9,3.3-11.6-5.1-6.7-23.1-3.1-32.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.1,14c-3.3,8-7.7,23.1-.5,30,7.4,6.7,21.9,1.6,30.1-1.5-8.2,3.1-22.8,8.2-30.2,1.6-7.2-6.9-2.7-21.9.6-30h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.6,14c-3.3,7.9-8,23.1-.9,29.9,7.3,6.5,22,1.2,30.1-1.9-8.1,3.1-22.8,8.5-30.1,2-7.2-6.8-2.4-22,.9-30h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.1,14c-3.3,7.8-8.4,23.1-1.3,29.9,7.2,6.4,22.2.8,30.1-2.4-7.9,3.2-22.9,8.8-30.1,2.4-7.1-6.8-2-22.1,1.3-29.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.5,14c-3.7,8.4-10.2,27.5,1.7,31.8,7.8,2.6,19.3-1.7,26.6-4.8-7.4,3.1-18.8,7.4-26.7,4.8-12-4.3-5.5-23.5-1.7-31.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51,14c-3.4,7.5-9.1,23.2-2,29.8,7.2,6.2,22.3,0,30-3.2-7.7,3.2-22.7,9.5-30,3.3-7.1-6.6-1.4-22.3,2.1-29.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.5,14c-4.5,9.6-12.2,31.5,4.9,32.2,7.9,0,15.5-3.1,22.7-6.1-7.2,3.1-14.7,6.2-22.7,6.2-17.2-.6-9.4-22.7-4.9-32.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52,14c-3.4,7.2-9.8,23.3-2.7,29.7,7,5.9,22.6-.8,29.9-4.1-7.4,3.3-22.9,10.1-30,4.1-7-6.4-.6-22.5,2.8-29.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.5,14c-3.4,7.1-10.1,23.4-3.1,29.6,7,5.8,22.6-1.2,29.9-4.5-7.3,3.3-22.9,10.4-29.9,4.6-7-6.3-.3-22.6,3.2-29.7h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.6,16.4c-9.9,16.4-14.4,38.8,2.3,52.4,4.9,4.1,10.9,6.8,16.9,8.8-6.1-2-12-4.7-16.9-8.8-16.8-13.6-12.2-36-2.3-52.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57,16.8c-.9,1.3-1.7,2.7-2.4,4.1-2.2,4.2-3.9,8.6-5,13.2-3.8,14.7-.8,28.8,12.4,37.5,3.9,2.6,8.3,4.6,12.7,6.1-4.5-1.5-8.8-3.4-12.8-6.1-9.8-6.5-14.7-16.6-13.9-28.3.4-6.3,2.1-12.5,4.6-18.3,1.3-2.9,2.6-5.8,4.4-8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57.4,17.2c-1,1.2-1.7,2.6-2.4,3.9-2.1,4.1-3.8,8.5-5,13-3.8,14.2-1.4,28.6,11.2,37.5,3.8,2.7,8.1,4.7,12.4,6.2-4.4-1.5-8.7-3.5-12.5-6.2-9.5-6.6-13.7-17-12.7-28.3.5-6.2,2.2-12.3,4.6-18,.6-1.4,1.3-2.8,2-4.2.7-1.4,1.4-2.8,2.5-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57.8,17.6c-1.1,1.1-1.7,2.5-2.5,3.8-2.1,4.1-3.8,8.4-5,12.8-3.2,11.8-2.5,25.3,6.5,34.4,4.3,4.4,9.8,7.4,15.6,9.4-5.8-2-11.3-5-15.6-9.4-9.1-9.1-9.8-22.6-6.5-34.4,1.2-4.4,2.8-8.7,5-12.8.7-1.3,1.4-2.7,2.5-3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.2,17.9c-1.1,1.1-1.8,2.4-2.5,3.7-2.1,4-3.7,8.2-4.9,12.6-3.6,13.2-2.5,28.2,8.8,37.3,3.5,2.9,7.6,5,11.8,6.5-4.2-1.5-8.3-3.6-11.8-6.5-11.4-9.2-12.5-24.1-8.8-37.3,1.2-4.4,2.8-8.6,5-12.6.7-1.3,1.5-2.7,2.5-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.6,18.3c-1.1,1-1.8,2.3-2.6,3.6-2.2,3.9-3.7,8.1-4.9,12.4-3.8,13.7-2.7,29.4,9.3,38.6,2.9,2.3,6.3,4,9.7,5.3-3.5-1.3-6.8-3-9.7-5.3-12.2-9.2-13.2-24.9-9.4-38.6,1.2-4.3,2.8-8.5,4.9-12.4.7-1.3,1.5-2.6,2.6-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.1,18.7c-3.5,3.5-6.2,10.9-7.5,15.7-3.5,12.4-3.3,27.5,6.5,37,3.1,3.1,7,5.3,11.1,7-4.1-1.6-7.9-3.9-11.1-6.9-9.8-9.5-10-24.7-6.5-37,1.2-4.2,2.7-8.4,4.9-12.2.7-1.2,1.5-2.5,2.6-3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.5,19.1c-3.6,3.5-6.1,10.5-7.5,15.4-3.8,13.4-3.4,30.5,8.6,39.8,2.3,1.8,4.8,3.2,7.5,4.3-2.7-1.1-5.2-2.5-7.5-4.3-12-9.2-12.5-26.3-8.6-39.8,1.4-4.8,3.9-11.9,7.6-15.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.9,19.4c-3.8,3.5-6.1,10.1-7.6,15-3.7,13.2-3.8,30,7.4,39.6,2.1,1.9,4.6,3.3,7.2,4.5-2.6-1.1-5.1-2.6-7.2-4.4-11.2-9.7-11.1-26.4-7.4-39.7,1.5-4.9,3.8-11.5,7.6-15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.3,19.8c-3.9,3.6-6.1,9.8-7.6,14.7-2.9,10.6-3.7,22.6,1.3,32.8,2.5,5,6.7,9.1,11.8,11.4-5.1-2.3-9.4-6.3-11.9-11.4-5-10.1-4.2-22.2-1.3-32.8,1.5-5,3.8-11.1,7.6-14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.7,20.2c-4,3.7-6.1,9.4-7.6,14.4-3.5,12.5-4.2,29,5,39.3,1.9,2,4.1,3.7,6.6,4.9-2.5-1.2-4.7-2.9-6.6-4.9-9.3-10.3-8.6-26.8-5.1-39.3,1.6-5.1,3.7-10.8,7.7-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.1,20.6c-4,3.7-6.1,9-7.7,14.1-3.5,12.1-4.2,28.7,3.9,39.1,1.7,2.1,3.8,3.9,6.2,5.2-2.4-1.3-4.5-3-6.2-5.2-8.2-10.5-7.5-26.9-4-39.1,1.6-5.1,3.7-10.4,7.7-14.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.5,20.9c-4,3.6-6.2,8.8-7.7,13.8-3.4,11.9-4.1,28.2,2.9,38.8,1.5,2.2,3.5,4.1,5.8,5.5-2.3-1.3-4.3-3.3-5.8-5.5-7.1-10.7-6.4-26.9-2.9-38.9,1.6-5,3.8-10.2,7.8-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.9,21.3c-11.5,10.3-13.4,39.1-5.8,52.1,1.3,2.3,3,4.4,5.2,5.8-2.2-1.4-4-3.5-5.3-5.8-7.6-13-5.7-41.7,5.9-52.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.4,21.7c-11.7,10.4-13.1,37.8-6.8,51.5,1.1,2.3,2.6,4.6,4.6,6.2-2.1-1.6-3.6-3.8-4.7-6.2-6.4-13.7-5-41,6.8-51.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.8,22.1c-12,10.5-12.8,36.7-7.6,50.8.9,2.4,2.1,4.7,3.9,6.5-1.9-1.8-3-4.1-4-6.5-5.2-14.2-4.5-40.2,7.6-50.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.1,74c5-10,7.1-22.1,3.3-32.9-.3-.8-.7-1.6-1-2.4-.4-.7-.8-1.6-1.2-2.3-.5-.9-1.2-2.1-1.8-2.8-.5-.8-1.5-1.9-2.1-2.7-1.9-2.1-4-4-6.3-5.7,2.3,1.7,4.4,3.6,6.3,5.7.6.8,1.6,1.8,2.1,2.7.6.8,1.3,2,1.9,2.8.4.7.8,1.6,1.2,2.3.3.8.7,1.6,1,2.4l.6,1.6c3.1,10.4.9,21.8-3.9,31.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.5,73.7c5.3-9.8,7.7-21.9,3.8-32.6-2.4-6.4-7.1-11.6-12.6-15.5,5.5,3.8,10.3,9.1,12.7,15.5,4,10.7,1.5,22.8-3.8,32.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.9,73.4c5.5-9.6,8.3-21.6,4.2-32.2-2.4-6.3-7.2-11.4-12.8-15.2,5.6,3.7,10.4,8.8,12.9,15.1,4.1,10.6,1.2,22.7-4.3,32.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.3,73.1c7-11.2,9.8-26.5,1.5-37.8-2.6-3.6-6-6.6-9.8-9,7.6,4.7,13.7,12.2,14.7,21.3,1.1,8.9-1.8,18-6.5,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.7,72.8c7.3-11,10.5-26.2,1.9-37.4-2.7-3.5-6.2-6.4-9.9-8.8,3.8,2.3,7.2,5.2,10,8.8,8.6,11.3,5.4,26.4-2,37.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.1,72.5c7.6-10.8,11.2-25.9,2.4-37-2.8-3.5-6.3-6.3-10.1-8.5,3.8,2.2,7.3,5.1,10.1,8.5,8.9,11.2,5.2,26.2-2.4,37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.5,72.2c7.3-9.8,11.5-23.7,4.2-34.6-2.9-4.4-7.1-7.7-11.7-10.3,4.5,2.6,8.8,5.9,11.7,10.3,7.3,11,3,24.8-4.3,34.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.9,71.8c8.1-10.4,12.7-25.2,3.2-36.2-2.8-3.4-6.5-6-10.3-8.1,3.9,2.1,7.5,4.7,10.3,8.1,9.5,11.1,4.9,25.9-3.2,36.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.3,71.5c8.4-10.1,13.4-24.9,3.6-35.8-2.9-3.3-6.6-5.8-10.4-7.9,3.9,2,7.6,4.5,10.5,7.8,9.9,11,4.8,25.7-3.6,35.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.7,71.2c8.6-9.9,14.1-24.6,4-35.4-3-3.2-6.7-5.7-10.6-7.6,3.9,2,7.6,4.4,10.6,7.6,10.2,10.9,4.6,25.5-4,35.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.2,70.9c8.8-9.7,14.9-24.2,4.4-35-3-3.2-6.8-5.5-10.7-7.4,3.9,1.9,7.7,4.2,10.7,7.4,10.5,10.8,4.4,25.4-4.4,35.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.6,70.6c5.8-6.1,11-14.5,10.4-23.1-.6-9.1-8.7-15.2-16.3-18.7,7.7,3.5,15.8,9.6,16.4,18.7.6,8.7-4.7,17.1-10.5,23.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25,70.3c5.8-5.9,11.4-14.2,10.9-22.8-.6-9.1-8.9-15-16.6-18.4,7.7,3.4,16,9.3,16.6,18.4.5,8.7-5.1,17-11,22.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.4,70c5.9-5.7,11.9-13.9,11.4-22.5-.6-9.1-9.1-14.8-16.8-18.1,7.7,3.2,16.3,8.9,16.8,18.1.5,8.6-5.5,16.8-11.5,22.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.8,69.7c9.6-8.7,17.9-22.9,6-33.4-3.2-2.9-7.1-4.9-11.1-6.6,4,1.6,7.9,3.7,11.2,6.6,12,10.5,3.6,24.8-6,33.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.2,69.3c6.1-5.3,12.7-13.4,12.4-21.9-.5-9.2-9.5-14.4-17.2-17.5,7.7,3,16.8,8.3,17.3,17.5.3,8.5-6.4,16.6-12.5,21.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27,18.1c11.5,9.6,20.6,24.7,4.4,34.8-4,2.5-8.5,4.2-13,5.6,4.5-1.4,9-3.1,13-5.7,16.2-10.2,7-25.2-4.4-34.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.8,17.9c10.5,9.6,19,24.6,4.4,34.9-4.1,2.9-8.8,4.8-13.6,6.3,4.8-1.5,9.5-3.4,13.6-6.3,14.6-10.3,6.1-25.3-4.3-34.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.7,17.7c10.4,10.3,17.7,25.8,2.9,35.9-3.9,2.7-8.3,4.5-12.7,5.9,4.5-1.4,8.8-3.3,12.7-5.9,14.7-10.1,7.4-25.6-2.9-35.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.5,17.5c6,6.6,11.8,16,10,25.2-2.1,9.6-11.9,14.5-20.4,17.3,8.5-2.8,18.3-7.8,20.3-17.3,1.8-9.2-4-18.6-9.9-25.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.4,17.3c5.7,6.9,10.8,16.4,9,25.6-2,9.6-11.5,14.8-20,17.6,8.5-2.8,18-8.1,20-17.7,1.8-9.2-3.3-18.7-8.9-25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.2,17.2c5.4,7.2,9.9,16.7,8.1,25.9-1.9,9.5-11.1,15.1-19.7,18,8.6-2.9,17.7-8.5,19.6-18,1.8-9.1-2.6-18.7-8-25.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32,17c7.9,11.5,12.1,27.7,0,37.9-3.5,3-7.8,5.1-12.2,6.6,4.4-1.6,8.6-3.6,12.1-6.7,12.1-10.2,7.9-26.4,0-37.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.9,16.8c8.5,14,10.9,31.8-5,41.5-2.5,1.5-5.1,2.8-7.8,3.7,2.7-1,5.4-2.2,7.8-3.8,15.8-9.7,13.4-27.5,5-41.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M33.7,16.6c8,15,9.5,33.5-7.1,43-2,1.2-4.1,2.1-6.3,3,2.2-.8,4.3-1.8,6.3-3,16.5-9.5,15.1-28.1,7.1-43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M34.6,16.4c6.4,13.5,8.3,31.5-4.9,41.6-2.7,2.2-5.9,3.8-9.1,5.1,3.2-1.3,6.4-2.9,9.1-5.1,13.1-10.1,11.3-28.1,4.9-41.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35.4,16.2c6.2,15.1,6.9,34.4-8.4,44.1-2,1.3-4.1,2.3-6.2,3.2,2.2-.9,4.3-1.9,6.2-3.2,15.2-9.7,14.5-29.1,8.4-44.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.2,16c4.9,13.8,5.7,32.1-6.3,42.5-2.6,2.3-5.7,4.1-8.9,5.5,3.2-1.4,6.3-3.2,8.9-5.5,11.9-10.5,11.1-28.7,6.3-42.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M37.1,15.9c4.5,15.2,4.4,35.1-9.7,45.2-1.9,1.4-4,2.5-6.1,3.4,2.1-.9,4.2-2.1,6.1-3.5,14-10.1,14.1-30.1,9.7-45.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M37.9,15.7c3.4,14.9,3.3,33.8-9,44.7-2.2,1.9-4.8,3.5-7.4,4.7,2.7-1.2,5.2-2.8,7.4-4.7,12.2-10.8,12.4-29.8,9-44.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M38.8,15.5c2.8,15.5,2.1,35.5-11,46.3-1.8,1.5-3.9,2.8-6,3.8,2.1-1,4.2-2.3,6-3.8,12.9-10.8,13.7-30.9,11-46.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.6,15.3c2,15.5.8,35.8-11.6,46.8-1.8,1.6-3.8,2.9-6,3.9,2.1-1.1,4.1-2.4,5.9-3.9,12.3-11,13.6-31.4,11.7-46.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.3,75.7c1.3-11.3,6.6-22.3,14.9-30.2,5.6-5.4,12.7-9.2,20.2-11.5-7.5,2.3-14.5,6.1-20.2,11.6-8.2,7.9-13.6,18.8-14.9,30.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40,75.8c-.2-.6,0-1.2,0-1.8.2-1.8.5-3.6.9-5.3,2.8-11.6,10-22.3,20.4-28.5,4.1-2.5,8.6-4.3,13.2-5.5-4.6,1.2-9.1,3.1-13.2,5.6-10.3,6.2-17.5,16.9-20.4,28.5-.4,1.7-.8,3.5-.9,5.3,0,.6-.1,1.2,0,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40.7,75.9c-.3-.5-.2-1.2-.2-1.8,0-1.8.3-3.6.7-5.3,2.5-11.7,9.7-22.5,20.1-28.4,4.1-2.4,8.7-4.1,13.3-5.1-9.3,2-18.1,6.9-24.2,14.4-4.6,5.5-7.7,12.2-9.3,19.2-.4,1.8-.6,3.5-.7,5.3,0,.6,0,1.2.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.5,76.1c-.6-1.1-.4-2.3-.4-3.5,0-1.2.2-2.4.4-3.5,1.3-7,4.4-13.7,8.9-19.3,6-7.5,15-12.1,24.4-13.7-9.4,1.6-18.3,6.3-24.3,13.8-4.5,5.5-7.7,12.2-8.9,19.2-.2,1.2-.4,2.4-.4,3.5,0,1.2-.1,2.4.4,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.2,76.2c-.6-1-.6-2.3-.7-3.5,0-1.2,0-2.4.2-3.6,1-7.1,4.1-13.8,8.6-19.3,6-7.5,15.1-12,24.5-13.2-9.4,1.2-18.5,5.7-24.5,13.2-4.5,5.5-7.6,12.2-8.6,19.3-.2,1.2-.3,2.4-.2,3.6,0,1.2,0,2.4.7,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43,76.3c-.7-1-.8-2.2-.9-3.4,0-1.2,0-2.4,0-3.6.7-7.1,3.7-13.9,8.2-19.4,6-7.5,15.3-11.8,24.7-12.6-9.4.8-18.7,5.2-24.6,12.7-4.5,5.5-7.5,12.3-8.2,19.4-.1,1.2-.2,2.4,0,3.6.1,1.2.2,2.4.9,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.7,76.5c-1.3-2-1.3-4.6-1.2-6.9.7-9.4,5.4-18.6,12.8-24.5,5.6-4.4,12.7-6.7,19.8-7-7.1.3-14.1,2.7-19.8,7.1-7.4,5.9-12.2,15-12.9,24.5,0,2.3,0,4.9,1.2,6.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M44.5,76.6c-1.3-2-1.5-4.5-1.5-6.8.3-9.4,5-18.8,12.4-24.6,5.7-4.3,12.8-6.5,19.9-6.5-7.1,0-14.2,2.2-19.9,6.5-7.4,5.8-12.2,15.1-12.4,24.5,0,2.3.2,4.8,1.5,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.2,76.7c-1.4-2-1.8-4.4-1.9-6.8-.2-9.5,4.5-18.9,12-24.7,5.7-4.3,13-6.3,20-5.9-7.1-.3-14.3,1.7-20,6-7.5,5.7-12.2,15.2-12,24.6,0,2.3.5,4.8,1.8,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46,76.8c-1.4-1.9-1.9-4.3-2.1-6.7-.6-9.4,4-19.1,11.6-24.8,5.8-4.2,13.1-6,20.2-5.3-7.1-.7-14.4,1.2-20.1,5.4-7.5,5.7-12.2,15.3-11.6,24.7.2,2.3.7,4.7,2.1,6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.7,77c-2.7-4-2.9-9.1-2.2-13.7,1.2-7,5.1-13.6,10.9-17.8,5.8-4.2,13.3-5.8,20.3-4.8-7-1-14.5.6-20.3,4.8-5.8,4.2-9.6,10.8-10.9,17.7-.8,4.6-.6,9.7,2.1,13.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.5,77.1c-5.4-7.9-2.8-19.5,2.8-26.6,5.8-7.6,16.2-10.9,25.5-9.1-9.3-1.9-19.7,1.5-25.5,9.1-5.6,7.1-8.2,18.7-2.9,26.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.2,77.2c-5.5-8-3.6-19.3,2.1-26.7,5.8-7.7,16.4-10.8,25.7-8.5-9.2-2.3-19.8.8-25.6,8.5-5.7,7.4-7.7,18.7-2.2,26.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.9,77.3c-7.1-9.9-3.4-25.1,6.6-31.6,6-4,13.7-5,20.6-3-6.9-2-14.6-1-20.5,3-9.9,6.6-13.7,21.7-6.6,31.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.7,77.5c-8.9-12.4-2.5-30.8,12.4-34.6,4.6-1.3,9.6-1,14.1.5-4.5-1.6-9.5-1.8-14.1-.5-14.8,3.8-21.3,22.2-12.4,34.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.4,77.6c-9.1-12.5-3.7-30.9,11.8-34.6,4.7-1.1,9.7-.8,14.1,1-4.5-1.8-9.5-2.2-14.1-1-15.4,3.7-20.9,22.1-11.8,34.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M66.7,71.4c-5.3-11.1-14.2-21-25.8-25.5l-1.8-.6c-.9-.3-1.9-.5-2.8-.8-.9-.2-2-.4-2.9-.5l-1.9-.2c-.6,0-1.4,0-1.9-.1-.6,0-1.4,0-2,0-2.6,0-5.2.4-7.8.9-.6,0-1.3.3-1.9.4l-1.9.5,1.9-.5c.6-.1,1.3-.4,1.9-.5,2.5-.5,5.2-.9,7.8-.9.6,0,1.4,0,2,0,.6,0,1.4,0,2,0l1.9.2c.9.1,2,.4,2.9.5,2.2.5,4.5,1.2,6.5,2.1,10.7,4.7,19,14.3,24,24.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M66.3,71.6c-4-8.8-10.2-16.9-18.4-22.2-9.6-6.2-21-7-31.8-3.7,10.7-3.3,22.3-2.6,31.8,3.6,8.2,5.3,14.4,13.4,18.4,22.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65.9,71.9c-3.7-8.9-9.9-17-18-22.3-9.5-6.2-21-6.8-31.7-3.4,10.6-3.4,22.3-2.8,31.7,3.4,8.1,5.3,14.2,13.5,18,22.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65.4,72.1c-3.8-9.5-10.3-18.4-19.2-23.5-9-5.3-20.2-5.4-30-2.2,9.8-3.2,20.9-3.2,30,2.1,9,5.2,15.4,14,19.2,23.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65,72.4c-4.6-12.8-14.8-24.8-28.7-27.3-6.7-1.3-13.6-.3-20,1.7,6.4-2.1,13.3-3,20-1.8,13.9,2.5,24.1,14.6,28.7,27.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64.6,72.6c-4.6-13.9-15.8-26.7-31.1-27.8-5.8-.5-11.6.5-17,2.3,5.5-1.8,11.3-2.8,17-2.3,15.4,1.1,26.5,14,31.1,27.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64.2,72.9c-4.4-14-15.2-26.9-30.7-27.9-5.7-.5-11.5.6-17,2.4,5.4-1.8,11.2-2.9,17-2.5,15.6,1,26.3,13.9,30.7,28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63.8,73.1c-3.4-12-11.9-23.9-24.6-27.1-7.5-2-15.4-.8-22.6,1.7,4.8-1.7,9.9-2.7,15-2.7,16.5-.2,27.9,13.2,32.1,28.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63.4,73.3c-4-15.1-15-28.3-31.7-28.1-5.1,0-10.1,1.1-14.9,2.8,4.8-1.7,9.8-2.8,14.9-2.8,16.8-.2,27.7,13,31.7,28.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.9,73.6c-3.6-15.3-14.3-28.6-31.2-28.2-5.1,0-10.1,1.2-14.9,2.9,4.8-1.7,9.8-2.9,14.9-3,16.9-.4,27.6,12.9,31.2,28.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.5,73.8c-2.1-9.8-7.3-19.6-16.1-24.7-9-5.3-20.1-3.9-29.4-.5,9.4-3.5,20.5-4.9,29.5.4,8.9,5.2,14,15,16.1,24.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.1,74.1c-1.9-9.8-6.8-19.8-15.7-24.9-9-5.2-20.1-3.7-29.4-.2,9.3-3.5,20.4-5.1,29.4.1,8.9,5.2,13.8,15.2,15.7,25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.7,74.3c-1.6-9.8-6.4-19.9-15.2-25.1-9-5.2-20-3.5-29.3,0,9.3-3.6,20.4-5.3,29.3,0,8.9,5.2,13.6,15.3,15.2,25.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.3,74.6c-1.4-9.8-5.9-20.1-14.8-25.2-9-5.2-20-3.3-29.2.3,9.2-3.6,20.3-5.5,29.3-.3,8.9,5.2,13.3,15.5,14.7,25.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.8,74.8c-1.2-9.8-5.4-20.3-14.3-25.4-9-5.2-20-3.1-29.2.5,9.2-3.6,20.2-5.7,29.2-.6,8.9,5.2,13.1,15.7,14.3,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.4,75.1c-1-9.8-5-20.4-13.8-25.6-9-5.2-20-2.9-29.2.7,9.1-3.6,20.2-5.9,29.2-.8,8.9,5.2,12.9,15.8,13.8,25.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.7,71.6c13.1-10.5,23.6-27.2,5.2-38.7-4.5-2.8-9.5-4.8-14.6-6.4,5.1,1.6,10.1,3.5,14.6,6.4,18.5,11.5,7.9,28.2-5.3,38.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.3,71.4c7.4-5.9,17.1-16,15.1-26.3-2.3-10.4-15.2-15.3-24.4-18.1,9.2,2.8,22.1,7.7,24.5,18.1,2,10.3-7.7,20.5-15.2,26.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.9,71.1c8.3-6.4,20-18.6,14.1-29.8-4.5-7.9-14.9-11.6-23.2-14.1,8.3,2.5,18.7,6.1,23.3,14,6,11.2-5.8,23.4-14.1,29.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.5,70.8c8.3-6.2,20.4-18.4,14.3-29.5-4.6-7.8-15.1-11.3-23.4-13.7,8.3,2.4,18.8,5.9,23.5,13.7,6.2,11.1-6.1,23.3-14.4,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.1,70.6c8.2-6.1,20.8-18.2,14.6-29.2-4.7-7.6-15.3-11-23.6-13.4,8.2,2.3,18.9,5.7,23.6,13.3,6.3,11-6.4,23.2-14.6,29.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.7,70.3c8.2-5.9,21.2-18.1,14.8-29-4.7-7.4-15.6-10.8-23.8-13,8.1,2.2,19.1,5.5,23.8,13,6.5,10.9-6.7,23.1-14.9,29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.3,70c7.3-5.1,18.6-15.2,16.6-25.1-2.3-9.8-16.8-14.1-25.4-16.3,8.6,2.2,23.2,6.4,25.5,16.3,2.1,9.9-9.3,20-16.6,25.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.9,69.8c7.2-5,18.9-15,16.8-24.8-2.4-9.8-17-13.8-25.6-15.9,8.2,2,19.1,5,24.2,12.3,6.8,10.7-7.3,22.9-15.4,28.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.5,69.5c7.2-4.9,19.2-14.9,17.1-24.6-2.4-9.6-17.3-13.5-25.9-15.5,8.5,2,23.5,5.8,25.9,15.5,2.1,9.8-10,19.7-17.2,24.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.1,69.2c7.1-4.7,19.5-14.7,17.4-24.3-2.4-9.5-17.7-13.2-26.1-15.2,8.4,1.9,23.7,5.6,26.1,15.1,2.1,9.7-10.3,19.6-17.5,24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.7,69c7.1-4.6,19.9-14.5,17.7-24.1-2.4-9.3-18-13-26.3-14.8,8.3,1.8,23.9,5.4,26.4,14.8,2.2,9.6-10.6,19.5-17.8,24.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.3,68.7c7.7-4.9,23.8-17.1,16.3-27.4-5-6.5-17-9.3-24.8-10.9,7.9,1.6,19.7,4.3,24.8,10.9,7.6,10.3-8.5,22.5-16.3,27.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.9,68.4c7-4.3,20.5-14.2,18.3-23.6-2.6-9.2-18.5-12.4-26.7-14,8.2,1.6,24.2,4.8,26.8,14,2.2,9.4-11.3,19.3-18.3,23.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.5,68.1c13.9-8.4,30.6-24.1,6.9-33.1-4.9-1.9-10.1-3-15.2-3.9,7.7,1.5,15.7,3,22.3,7.5,13.9,10.1-4.8,24.1-13.9,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.1,67.9c6.8-4.1,21.1-13.9,18.8-23.1-2.5-8.8-19.2-11.9-27.1-13.3,7.8,1.4,19.9,3.7,25.3,9.8,8.2,9.9-9.5,22.1-17,26.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.7,67.6c6.8-4,21.4-13.8,19.1-22.9-2.6-8.7-19.5-11.6-27.3-12.9,7.9,1.3,24.8,4.2,27.4,12.9,2.3,9.1-12.4,18.9-19.2,22.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.3,19c-6.3,12.2-6.7,26.8-3.5,40,1.1,4.4,2.6,8.7,4.4,12.9-1.9-4.2-3.4-8.5-4.5-12.9-3.3-13.2-2.8-27.8,3.5-40h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.9,19.5c-.5.3-.7.9-1.1,1.3-.9,1.5-1.6,3-2.2,4.6-4,10.7-4.2,22.6-.8,33.5,1.3,4.4,3.1,8.6,5,12.7-2-4.1-3.7-8.3-5.1-12.7-3.5-10.8-3.2-22.8.8-33.5.6-1.6,1.3-3.2,2.2-4.6.3-.5.6-1,1.1-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.5,20c-1.5.5-3.1,4.1-3.8,5.5-2.7,6.3-3.8,13.2-3.6,20,.3,9.2,4.2,17.7,8.4,25.7-4.2-8-8.1-16.6-8.5-25.7-.1-6.8,1-13.7,3.7-20,.7-1.6,1.5-3.1,2.5-4.4.4-.4.7-.9,1.3-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M71.1,20.4c-1.8.4-3.5,3.6-4.3,5.1-3.8,7.7-5.4,18.3-3.2,26.7,1.8,6.6,5.1,12.7,8.5,18.6-3.4-5.9-6.8-12-8.5-18.6-2.2-8.3-.6-19,3.2-26.7.8-1.6,2.5-4.7,4.3-5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M71.6,20.9c-2,.4-3.7,3.1-4.7,4.7-3.4,6-4.7,13-4.7,19.8.3,9.2,5.8,17.4,10.5,25-3.7-5.8-7.4-11.7-9.4-18.3-2.6-8-.5-19.4,3.7-26.6,1-1.7,2.7-4.3,4.8-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.2,21.4c-1.2.1-2.1.9-3,1.7-.8.8-1.5,1.7-2.2,2.7-3.8,5.8-5.3,12.9-5.3,19.8.2,9.1,6.6,17.4,11.5,24.7-4-5.6-8.1-11.3-10.4-17.9-2.9-7.7-.4-19.8,4.2-26.6,1.3-1.8,2.9-4,5.2-4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.8,21.9c-2.3.3-4.1,2.2-5.5,4-4.2,5.6-5.9,12.8-6,19.7.2,9.1,7.3,17.4,12.6,24.3-5.2-7-12.5-15.2-12.6-24.3.1-6.9,1.9-14.1,6.1-19.7,1.4-1.8,3.2-3.6,5.5-4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.4,22.4c-2.4.3-4.3,1.9-5.8,3.6-4.6,5.4-6.5,12.6-6.7,19.6,0,9,8.1,17.3,13.6,24-4.5-5.3-9.4-10.6-12.2-17.1-.9-2.2-1.5-4.5-1.5-6.8.1-4.7,1.1-9.4,3-13.7,1.8-3.8,5.1-8.9,9.6-9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74,22.8c-2.4.2-4.5,1.7-6.1,3.3-5,5.1-7.2,12.4-7.4,19.4,0,2.4.6,4.7,1.6,6.8,3.1,6.5,8.3,11.5,13.1,16.7-4.8-5.2-10-10.2-13.1-16.7-1-2.1-1.6-4.5-1.6-6.9.3-7,2.5-14.3,7.5-19.5,1.7-1.6,3.7-3.1,6.1-3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.6,23.3c-2.4.2-4.6,1.5-6.4,3-5.4,4.8-7.9,12.2-8.2,19.3-.1,4.9,2.7,9.2,5.7,12.8,3,3.7,6.5,7,10,10.3-5.1-5-10.7-9.8-14-16.3-1.8-3.5-2-6.6-1.4-10.5.9-5.9,3.4-11.7,7.9-15.7,1.8-1.6,4-2.8,6.4-3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.1,23.8c-2.4.2-4.7,1.3-6.6,2.8-5.8,4.5-8.6,12-9,19.2-.1,9.1,10.5,17.1,16.7,22.8-6.2-5.6-16.9-13.6-16.8-22.8.4-7.2,3.3-14.6,9-19.2,1.9-1.5,4.2-2.6,6.6-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.7,24.3c-10.2,1.2-16.2,12.1-16.6,21.5,0,1.2.1,2.4.5,3.6,2.6,7.8,11.1,13.7,17.2,18.7-6.2-5.1-14.6-10.9-17.3-18.7-.4-1.2-.6-2.4-.5-3.6.5-9.5,6.5-20.3,16.7-21.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.3,24.8c-10.3,1-17.1,11.4-17.6,21.2-.2,9.1,12.2,17,18.8,21.9-6.6-4.9-19.1-12.8-18.8-21.9.5-9.8,7.4-20.1,17.7-21.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.9,25.2c-10.4.9-18.1,10.8-18.6,20.8-.1,2.5.9,5,2.3,7,4.5,6.2,11.2,10.3,17.4,14.4-6.3-4.1-13-8.2-17.5-14.4-1.4-2.1-2.5-4.5-2.4-7.1.6-10.1,8.3-19.9,18.7-20.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.5,25.7c-10.4.8-19,10.1-19.7,20.4-.1,2.6,1,5,2.5,7.1,4.8,6.1,11.7,10,18.3,13.9-6.6-3.9-13.6-7.7-18.3-13.9-1.5-2.1-2.7-4.5-2.6-7.1.7-10.3,9.3-19.7,19.7-20.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.1,26.2c-7.8.6-15.2,5.5-18.6,12.6-1.1,2.3-1.9,4.9-2.1,7.5,0,.6,0,1.3.1,1.9,1.9,8.4,14.6,14.8,21.7,18.6-7.1-3.7-22.2-11.3-21.9-20.5.8-10.7,10.2-19.3,20.8-20.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.8,58.9c-9.7-3-18-10.6-21.4-20.2-2.8-7.4-2.9-15.6-1.6-23.4-1.3,8-1,16.5,2,24.2,3.6,9.2,11.6,16.5,21.1,19.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76,58.5c-12.4-3.4-21.3-13.6-23.1-26.3-.9-5.5-.6-11.2.3-16.8-.9,5.5-1.1,11.2-.2,16.8,1.9,12.6,10.7,22.9,23.1,26.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.2,58c-8.7-2-16.4-8.1-20.2-16.2-3.8-8.2-3.9-17.5-2.4-26.3-1.5,8.7-1.4,18.1,2.4,26.2,3.8,8.1,11.5,14.2,20.2,16.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.4,57.6c-6.5-1.3-12.6-4.9-16.8-10.1-3.2-3.9-5.1-8.7-6-13.6-1.1-6-.7-12.2.4-18.2-1.1,6-1.4,12.2-.3,18.2.9,4.9,2.8,9.7,6,13.5,4.2,5.2,10.2,8.8,16.7,10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.5,57.1c-9.4-1.5-17.5-7.9-21-16.8-2.9-7.8-2.7-16.4-1.2-24.5-1.6,8.6-1.8,17.9,1.9,26,3.6,8.1,11.5,13.9,20.3,15.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.7,56.7c-8.7-1.1-16.9-6.7-20.4-14.8-1.4-3-2.1-6.3-2.5-9.5,0-.5-.1-1.2-.1-1.6,0-.9-.1-2.4,0-3.3,0-3.8.5-7.7,1.2-11.4-.7,3.7-1.2,7.7-1.2,11.4,0,4.9.7,10,2.8,14.4,3.5,8.1,11.6,13.8,20.3,14.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.9,56.2c-9.5-.9-17.8-6.8-21-15.9-2.8-7.8-2.2-16.3-.6-24.3-1.5,8-2.1,16.5.7,24.2.9,2.5,2.3,5,4,7.1,4.1,5.1,10.5,8.2,17,8.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.1,55.8c-10.3-.7-18.7-6.9-21.6-17-2.1-7.4-1.4-15.2.1-22.6-1.5,7.4-2.1,15.2,0,22.6.9,3.1,2.4,6.1,4.4,8.6,4.1,5.1,10.6,8,17,8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.3,55.3c-8.8-.2-17.2-5.1-20.5-13.5-3.3-8.1-2.4-17.2-.7-25.6-1.7,8.4-2.5,17.5.8,25.5,3.3,8.3,11.7,13.3,20.4,13.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.5,54.9c-9.5,0-18.2-5.2-21.1-14.5-2.5-7.7-1.5-16.1,0-23.9-1.6,7.8-2.6,16.2,0,23.9,2.9,9.3,11.5,14.5,21,14.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.7,54.4c-8.7.4-17.5-4.1-20.6-12.5-.6-1.5-1-3.1-1.3-4.6-.1-.9-.4-2.3-.4-3.2-.5-5.9.3-11.8,1.6-17.5-1.2,5.7-2.1,11.7-1.5,17.5,0,.9.3,2.3.4,3.2.3,1.6.7,3.1,1.3,4.6,3.1,8.4,11.8,12.9,20.5,12.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.9,54c-4.2.3-8.6-.5-12.4-2.5-4.6-2.4-7.6-6.9-8.9-11.8-1.9-7.6-.9-15.5.8-23-1.7,7.5-2.7,15.4-.7,23,.8,2.8,2,5.5,4,7.8,4.1,5,11,7,17.3,6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.1,53.5c-6.3.7-13.2-1.1-17.4-6-3-3.5-4.3-8-4.7-12.5-.5-6.1.4-12.2,1.8-18.2-1.3,5.9-2.3,12.1-1.8,18.2.4,4.5,1.7,9,4.7,12.5,4.2,5,11.1,6.7,17.4,6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.2,53.1c-8.9,1.2-17.5-2.2-20.6-11-2.7-8.1-1.3-17,.6-25.1-1.9,8.2-3.2,17-.5,25.1,3.1,8.9,11.7,12.3,20.6,11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.4,52.7c-6.1,1.1-13.3-.1-17.5-5.1-6.8-8-4.5-21.1-2.3-30.5-2.2,9.5-4.4,22.4,2.4,30.5,4.2,4.9,11.3,6.1,17.5,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.6,52.2c-8.7,1.8-17.7-.9-20.6-10-2.6-8.1-.9-16.9,1-25-1.9,8.1-3.5,16.8-1,24.9,2.9,9.1,11.9,11.8,20.6,10.1h0Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 45.6,
    cy: 46.1,
    r: 26.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 21.6,
    cy: 17.3,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.5,22.1s0,.2,0,.2c0,0,0,.2.1.2.1.2.3.3.4.5,0,0,0,.1.1.2s0,.1,0,.2c0,0-.1,0-.2,0s-.1,0-.2,0c0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,.1-.1.1s-.1,0-.2,0c0,0,0,0,0-.1s0,0,0,0l-.2.2c0,0-.1,0-.2,0,0,0,0,0,0-.1s0-.1,0-.2c0-.1.1-.2.2-.3,0-.1.1-.2,0-.4,0,0-.2-.3-.2-.3.1,0,.2-.1.4-.1h.4s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.4,21.5c-.1.1-.2.3-.1.5,0,.1.2.2.2.3,0,.1-.2.2,0,.3s0,.2,0,.3-.2,0-.3,0-.1-.2-.2-.3c-.2,0-.3,0-.5,0,0,0,0,0,0,0-.1-.2,0-.6.3-.7,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0-.3.1,0,.3,0,.4,0l.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.9,17.9c-.2,0-.4,0-.5.1,0,.1,0,.3-.1.3,0,0-.3,0-.3,0s-.2.1-.3,0-.1-.2,0-.3,0-.2.1-.3c-.1-.1-.2-.3-.2-.4,0,0,0,0,0,0,.1-.3.5-.3.7-.1,0,0,0,0,0,0s0,0,0,0c0,0,.2-.1.2-.2.1,0,.2.2.2.4v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M18.4,13.8c0-.2-.2-.3-.4-.3-.1,0-.2.1-.3,0,0,0-.1-.2-.2-.2s-.2,0-.2-.2,0-.2.2-.2.2,0,.3,0c0-.2.1-.3.2-.5,0,0,0,0,0,0,.3,0,.6.2.5.5,0,0,0,0,0,0,0,0,0,0,0,0h.3c0,.2,0,.3-.2.4l-.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M20.4,12.8c0-.2,0-.4-.2-.4-.1,0-.3,0-.3,0,0,0,0-.3-.1-.3s-.2-.1-.1-.2.2-.1.3-.1.2,0,.3.1c.1-.1.3-.2.4-.3,0,0,0,0,0,0,.3,0,.4.5.2.7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2.1.2.2,0,.1-.2.2-.3.2h-.4c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.6,12.8s0-.2,0-.3c0-.1,0-.2-.1-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.2,0,0,0,0,0-.1s0,0,0-.1c0,0,0,0,.1,0s0,0,0,0c0,0,0,0,0,.1,0,0,0,0,.2,0,0,0,.2,0,.3,0s.2,0,.2.1c0,0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,0,0,0,0,0,0,.2,0,.3,0,0,0,.3,0,.3,0,0-.2,0-.3,0,0,0-.4-.1-.4-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M24.6,13.8c.1-.1.3-.2.3-.4,0-.1-.1-.2-.1-.3,0-.1.2-.2.2-.3s0-.2.1-.2.2,0,.3.2,0,.2,0,.3c.2,0,.3,0,.5.2,0,0,0,0,0,0,0,.3-.2.6-.5.6,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3-.1,0-.3,0-.4-.1l-.3-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26.3,16.3c0-.2.2-.3.4-.3,0,0,.2,0,.3,0,0,0,.2,0,.2-.2,0-.1,0-.2,0-.3,0,0,0,0,0,0,0,0-.1,0-.2-.1,0,0,0-.2,0-.3,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1.2-.2.2,0,0,0,.1-.1.1-.2.1-.4.2-.7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26.2,17.9c.2,0,.4.1.5,0,0,0,0-.2.2-.3.1,0,.3,0,.3,0s.2-.1.3,0,0,.2,0,.3-.1.2-.2.2c0,.2.1.3.1.5,0,0,0,0,0,0-.2.2-.6.2-.7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2,0-.3.1,0-.1-.1-.3,0-.4v-.4c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M25.4,20c0,.1.2.2.4.3,0,0,0,0,.1,0,.1,0,.2-.1.3-.2.1,0,.3,0,.4,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0-.1,0-.2.1,0,0-.2,0-.1.2,0,0,0,0,0,0,0,0,.1.2.1.3s-.1.2-.2.1c0,0-.1-.1-.2,0,0,0,0,0,0,.1,0,0,0,0-.1,0s0,0,0-.1c0-.1-.1-.3-.2-.4,0,0-.4,0-.4,0,0-.1,0-.3,0-.4,0-.1.2-.2.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.7,21.5c0,.2.1.4.3.4.1,0,.3,0,.3,0,0,0,0,.3.2.2s.2.1.2.2-.1.2-.2.2-.2,0-.3,0c0,.1-.2.3-.3.4,0,0,0,0,0,0-.3,0-.5-.4-.4-.6,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2-.1-.3-.2,0-.1.1-.2.3-.3l.4-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.2,15.7c-.1,0-.3,0-.4,0,0,0-.1,0-.2,0-.1,0-.1.2-.2.3,0,.1-.3.2-.4,0,0,0,0,0,0-.1s0,0,0-.1c0,0,0-.1.1-.2,0,0,.1-.2,0-.2,0,0,0,0,0,0,0,0-.2-.1-.2-.2s0-.2.1-.2c0,0,.2,0,.2,0,0,0,0-.1,0-.2,0,0,0,0,.1,0s0,0,.1,0c.1,0,.3.2.4.3,0,0,.4-.1.4-.1,0,.1,0,.3,0,.4,0,.1,0,.3,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.7,20.2s-.2,0-.2,0c0,0-.1.1-.2.2,0,.2-.2.4-.3.6,0,0,0,.1-.1.2s-.1,0-.2,0c0,0-.1,0-.1-.2s0-.2,0-.2c0,0,0,0,0-.1,0,0,0,0,0,0,0,0-.1,0-.2,0s0-.1,0-.2c0,0,0,0,0,0s0,0,0,0h-.2c0-.2-.1-.2-.1-.3,0,0,0-.1,0-.1s.1,0,.2,0c.1,0,.2,0,.4,0,.1,0,.3,0,.4,0,0,0,.2-.3.2-.3.1,0,.2.2.3.3l.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.8,12.5c0-.2,0-.4,0-.6,0,0,0,0,0,0s0,0,0,0c0,.2,0,.5,0,.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.9,13c0-.2.2-.4.4-.5,0,0,0,0,0,0s0,0,0,0c-.1.2-.2.4-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M25.7,14.8c.2-.1.5-.2.7-.4,0,0,0,0,0,.1,0,0,0,.1-.1.1-.2.1-.4.3-.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26.4,16.8c.3,0,.5,0,.7,0,0,0,0,0,0,0s0,0,0,0c-.2,0-.5.1-.7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26,19.2c.3.1.6.3.8.4,0,0,0,.1-.1.2-.3-.1-.7-.2-1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M24.3,21.2c.2.2.5.4.7.6h.2c0-.1,0-.1,0-.1,0,0,0,0,0,0-.2-.2-.4-.5-.6-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.2,22.1c0,.3.1.5.2.7,0,0,0,0,.1,0-.1-.3-.2-.5-.3-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M20.1,21.8c0,.3-.2.6-.3,1h.1c.2-.3.3-.6.5-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M18.3,20.6c-.3.2-.6.5-.8.8,0,0,0,0,.1,0,.3-.1.6-.3.9-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17,18.7c-.2,0-.4.2-.6.2,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.4,0s.2,0,.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.8,16.6c-.3,0-.6,0-.8-.2,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c.1,0,.2,0,.4,0,.2,0,.4,0,.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.7,14.5c0,0-.2,0-.2-.1-.1,0-.2-.2-.3-.3,0,0-.1-.1-.2-.2,0,0,0,0,0-.1s0,0,.1,0,0,0,.1,0c.2.1.5.3.7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.3,13l-.5-.8c0,0,.2,0,.2,0,.1.3.3.5.5.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89,37.2c0-.5-.2-.6-1-.6-1.1,0-2.6.6-4.1,1.9-.6.5-.9,1-1,1.6,0-.2,0-.4-.2-.5.1,0,.2-.1.2-.2s-.1-.2-.3-.3c.2-1,.6-1.4.9-1.6.2-.2.4-.2.5-.2,0,0,.2,0,.4,0,0,0,.1-.2-.2-.1,0,0-.1,0-.1,0,0,0-.3,0-.6.2-.2.1-.4.3-.5.6-.2.3-.3.7-.4,1.1,0,0,0,0-.1,0s0,0-.1,0c-.1-.4-.2-.8-.4-1.1-.1-.2-.3-.4-.5-.6-.3-.2-.5-.2-.6-.2,0,0,0,0-.1,0-.3,0-.2.1-.2.1.2,0,.3,0,.4,0,0,0,.3,0,.5.2.3.2.7.6.9,1.6-.2,0-.3.2-.3.3s0,.2.2.2c0,.1-.1.3-.2.5-.2-.5-.4-1.1-1-1.6-1.5-1.2-3-1.8-4.1-1.9-.8,0-.9,0-1,.6,0,.5.4,1.3.4,1.5,0,.2.4,2.1,1.1,1.9.6-.1,1,0,1.2,0,0,0-.3,0-.8.4-.6.5-.5.9-.1,1.7.3.9,1.8,2,2.8,1.9.8,0,1.5-2.1,1.7-2.7h0c0,.9.2,1.6.4,1.6s.4-.7.4-1.5h0c.2.5.8,2.5,1.7,2.6,1,.1,2.4-1,2.8-1.9.3-.9.5-1.3-.1-1.7-.5-.4-.7-.4-.8-.4.1,0,.6-.2,1.2,0,.7.2,1.1-1.7,1.1-1.9,0-.2.5-1.1.4-1.5h0ZM82.1,41.5s0,0,0-.1c0,0,0,0,0,0,0,0,0,0,0,0h0ZM82.7,41.4s0,0,0,0c0,0,0,0,0,.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.9,65.2s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0-.1,0-.2,0s-.1,0-.2,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0-.1,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1-.1,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0-.1-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0-.1-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1-.1-.2-.2,0,0,0-.1-.1-.2,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,0,0,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0-.1.1-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v.2c.2,0,.2,0,.3.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1.1.2,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1.1,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,.1.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1.1.2,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.1.2,0,0,0,0,0,.1,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0h0c0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.2,61.4c0,.4,0,.8,0,1.2.1.8.1,1.7.8,2.3.3.3.6.6.8,1,.2.3.5.6.6.9.1.4.1.7.2,1.1,0-.4,0-.7-.2-1.1-.1-.4-.4-.6-.6-.9-.2-.4-.5-.7-.8-.9-.7-.5-.8-1.5-.9-2.3,0-.4,0-.8,0-1.3h.2s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.8,64.2c.2.6.4,1.3.7,1.9.1.3.3.5.5.8.2.6.8,1,1.1,1.5.4.8.7,1.8.7,2.7,0,.2,0,.4-.1.7,0-.2,0-.4,0-.7,0-.9-.3-1.8-.7-2.7-.2-.4-.6-.7-.9-1.1-.2-.4-.5-.8-.7-1.2-.1-.2-.2-.5-.3-.7-.2-.4-.3-.8-.4-1.1h.2c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.2,64s.6.3.5.3c.2,0,.5.1.6.3.2.2.3.3.5.5.3.5.7.9,1,1.3.6.6.8,1.4,1.4,2,.4.3.7.9,1.3.8h.8s-.8,0-.8,0c-.6.1-.9-.5-1.3-.8-.4-.4-.7-.9-.9-1.3-.3-.4-.7-.9-1.1-1.3-.3-.3-.4-.6-.8-.9-.3-.3-.4-.4-.8-.5,0,0-.5-.2-.5-.2v-.2h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.7,60c.6-.1,1.2,0,1.8,0,.3,0,.6.2.8.3.4.2.8.4,1.1.7.3.3.5.7.9,1,.3.3.7.5,1.1.7.1,0,.3,0,.4,0-.1,0-.3,0-.4,0-.4-.1-.8-.4-1.1-.6-.4-.2-.6-.7-.9-.9-.3-.3-.7-.5-1.1-.7-.3-.1-.5-.3-.8-.3-.5,0-1.2-.2-1.7,0v-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.5,63.5c.1.4,0,.7.4,1l.2.3c.4.3.7.8.9,1.2.5.6.6,1.4.8,2.1.2.6.7,1,.9,1.6-.1-.4-.4-.6-.6-.9-.4-.6-.4-1.4-.8-2.1-.3-.4-.6-.8-.9-1.2-.3-.4-.8-.7-1-1.1,0-.3-.1-.5-.2-.7h.2c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.1,60.9c.2.3.5.3.8.4.3,0,.7.2.9.5,1.1,1.2,2.2,2.5,3.5,3.6.3.2.6.4.9.3-.3,0-.7,0-.9-.3-1.3-1-2.4-2.3-3.6-3.5-.3-.4-.9-.4-1.3-.5-.2,0-.3-.2-.5-.3h.2c0-.1,0-.1,0-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.4,61.1s0,0,0,.1c0,0,0,.2,0,.3,0,0,0,0,0,.1,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0,0-.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.5,61.4c0,0,0,.2,0,.3,0,0,0,.2,0,.3,0,0,0,0,0-.1,0-.1,0-.2,0-.4,0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.8,61.6c0,0,0,.2,0,.2s0,.1,0,.2c0,0,0-.1,0-.2h0c0-.1,0-.2,0-.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9,61.9c0,.2-.1.3-.2.5,0,0,0-.2,0-.2,0,0,0-.2,0-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.7,62.6c0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,.1,0,.2,0-.1,0-.3,0-.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.8,62.9s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,.2,0,.3,0,0,0-.2,0-.3,0,0,0-.2,0-.2,0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.1,63.2c0,0,0,0,0,.2,0,.1,0,.1,0,.2h0c0,0,0-.2,0-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.3,63.3s0,0,0,0c0,0,0,.2,0,.3,0,0,0,0,0,.1,0,0,0,0,0-.1,0,0,0-.2,0-.3,0,0,0-.1,0-.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.5,63.7c0,.1,0,.2,0,.3,0,.1,0,.2,0,.3,0,0-.1-.2-.1-.3,0,0,0-.2,0-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.7,63.8c0,.1,0,.1,0,.2,0,0,0,0,0,.2,0,0,0,.2-.1.2,0,0,0,0,0-.1,0,0,0-.1,0-.2,0-.1,0-.1,0-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.1,64.2s0,0,0,.1c0,0,0,.2,0,.2,0,.1,0,.2,0,.3,0,0,0-.1,0-.1,0,0,0-.2,0-.3,0,0,0-.1,0-.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.3,64.5c0,.1,0,.2,0,.3,0-.1-.1-.2,0-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.6,64.8s0,0,0,0c0,0,0,.1,0,.2,0,0,0-.1,0-.2,0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.8,64.9c0,.1,0,.2,0,.3,0,.1,0,.2,0,.3,0-.1-.1-.3,0-.4,0,0,0-.1,0-.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12,65.2c0,0,0,.2,0,.2h0c0,.1,0,.2,0,.2,0,0,0,0,0-.1,0,0-.1-.1-.1-.2h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.2,65.4c0,.1,0,.2.2.3,0,0,0,0-.1-.1,0,0,0,0-.1-.1h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.6,65.4c0,.1,0,.3.2.4,0,0-.1-.2-.2-.3,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.7,58.9s.1-.1.1-.1c0,0,0,0,0,0,.1,0,.3,0,.4,0-.2,0-.3,0-.4,0,0,0,0,0-.1.1h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.2,59s0,0,0,0c0,0,0,0,0,0,0,0,.2,0,.3,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.6,59.2c0,0,.3,0,.3.1,0,0-.1,0-.2,0h-.2s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.7,59.5s0,0,0,0h0c.1,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0-.1,0-.1,0,0,0-.2,0-.2,0,0,0-.1,0-.2,0,0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.8,59.6s.2,0,.3,0c0,0,.1,0,.2,0,0,0-.2,0-.3,0,0,0,0,0-.1,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.1,59.9c0,0,.2,0,.2,0,0,0-.2,0-.2,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.5,60.3s.1,0,.2,0c.1,0,.2.1.4.2-.1,0-.3-.1-.4,0,0,0,0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.8,60.7s0,0,0,0c0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.3,61s0,0,0,0c0,0,.2,0,.2,0,0,0-.2,0-.2,0,0,0,0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.5,61.2c0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0-.1,0-.1,0h0s0,0,0,0c0,0-.1,0-.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.7,61.4c.1,0,.2,0,.3.1,0,0,0,0,0,0,0,0-.2,0-.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.2,61.8c0,0-.1,0-.2,0,0,0-.2,0-.2,0h0c0,0,0,0,.1,0,.1,0,.2,0,.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.1,62c0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,0,0,.1,0,0,0,0,0-.1,0h-.3s-.1,0-.1,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.3,62.3c0,0,0,0,0,0,0,0,.2,0,.2,0,0,0,0,0-.1,0,0,0-.1,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.1,61.9c.1,0,.2,0,.4,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.5,62.4s.1,0,.2,0h0s0,0,0,0c0,0,.1,0,.2,0,0,0-.1,0-.2,0s0,0,0,0h0,0c0,0-.1,0-.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.8,62.8s0,0,0,0h0c0,0,.2,0,.2.1,0,0-.1,0-.2,0,0,0-.1,0-.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.8,63.1s0,0,0,0c0,0,.1,0,.1,0,0,0,0,0,.1,0,.1,0,.3.1.3.2-.1-.1-.3-.2-.4-.1h0s0,0-.1,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.1,63.2c0,0,.2,0,.2.1,0,0,.2.1.2.2,0,0-.1-.1-.2-.2,0,0-.2,0-.3-.1h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.2,63.5c0,0,.1.2.2.2,0,0-.2,0-.3-.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.3,63.8c0,0,0,0,0,0,0,0,.2.1.2.2,0,0-.1,0-.2-.1,0,0-.1,0-.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.8,65.5c0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0-.1,0,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.4,65.4c0,.1,0,.1,0,.1,0,0,0,0,0,.1,0,0-.1-.1-.1-.2h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.6,65.3c0,0,0,.1,0,.2,0,0,0,0,.1.1,0,0-.1,0-.2-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.8,65.2c0,0,.1.1.1.2,0,0,.1.2.1.2,0,0-.2-.1-.2-.2,0,0,0,0,0,0h0c0,0,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14,65.1s0,.2.1.2c0,0,0-.1-.2-.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.1,65c0,0,.2.1.2.2,0,0-.1,0-.2-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.1,64.9c.1,0,.3,0,.4.1,0,0-.1,0-.2,0,0,0-.1,0-.2,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.1,64.7c.2,0,.3,0,.3.2,0,0-.1,0-.2,0,0,0-.1,0-.2,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.3,64.5c.1,0,.1.1.2.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1-.1-.2-.1h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.3,60.9s0,0-.1,0c0,0-.1.1-.2.2h-.1c0,0,.1,0,.2-.1,0,0,0-.2.1-.2h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.2,60.8c0,0,0,0,0,0h0c0,0-.1,0-.2.1,0,0,.1,0,.2-.1h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.1,60.6h0s0,0,0,0c0,0,0,0-.1,0-.1,0-.2,0-.3,0,0,0,.2-.1.3-.2,0,0,0,0,0,0,0,0,0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.2,60.3c0,0-.2,0-.2,0,0,0-.2,0-.3,0,0,0,.2,0,.3,0,0,0,.2-.1.3,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.3,59.9c0,0-.1.1-.2.1,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.1-.1.2-.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.4,59.7c-.1.1-.3,0-.4,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.6,59.4c-.1,0-.3,0-.4,0,0,0,.3,0,.3,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.6,59.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.8,59.2c0,0,0-.2-.2-.2,0,0,0-.2,0-.3,0,0,0,.2,0,.3,0,0,.1.1.2.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9,59.1s0-.2,0-.2c0,0,0-.2,0-.2,0,.1,0,.3.1.4,0,0,0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.2,59c0-.1,0-.2,0-.3,0,0,0-.2.1-.2,0,0,0,.2,0,.3,0,0,0,.2,0,.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.4,58.9c0-.1.2-.2.3-.3.1,0,.1,0,0,0-.1,0-.2.1-.2.3h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M48.5,1.6c-.9,2-2.4,5-3.3,7.1-.6,1.2-1.1,2.3-1.7,3.5-.7,1.1-.9,2.5-.1,3.6l-.4.2c-.2-.6-.4-1.3-.3-2,0-.7.3-1.3.6-1.9.6-1.2,1.1-2.3,1.7-3.5,1-2,2.5-5,3.6-7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.7,14c-.1,0-.3,0-.4,0-.1,0-.1-.2-.1-.4,0-.2.1-.3.3-.4s.3,0,.5,0c.2,0,.4,0,.6,0,0,0,0-.3,0-.4s-.2-.2-.3-.2c-.3-.1-.5-.2-.8-.3-.2,0-.3-.2-.4-.3-.2-.2-.3-.5-.2-.8,0,0,0-.1,0-.1,0,0,0,0,.1,0,.2,0,.4.1.6.2s.3.3.5.5c.3.2.6.4.9.6,0-.2-.2-.5-.3-.6s-.2-.2-.4-.4c-.4-.3-.7-.8-.8-1.3,0-.1,0-.2,0-.3s.1-.2.2-.2c.4.1.6.5.8.8.1.2.3.5.5.6,0,0,.3.1.4,0,0,0,0-.3,0-.4-.2-.5-.5-1-.7-1.5-.2-.3-.3-.6-.4-1s0-.7.2-1.1c0,0,0,0,0,0,0,0,0,0,0,0,.1.1.2.3.3.5s0,.4,0,.5c0,.4.2.7.4,1,0,.1.2.3.3.4,0,0,.2.5.3.5,0,0,0-.5,0-.8-.2-.6-.6-1.2-.7-1.8,0-.3-.1-.6,0-.9s0-.6.3-.8c0,0,0,.2.1.2,0,.4,0,.7.2,1s.3.6.4.9c.1.2.2.5.5.5,0-.9-.7-1.7-.8-2.7,0-.2,0-.3,0-.4.3.6.6,1.2.9,1.7,0,.1.3.1.4,0s0-.3,0-.5-.2-.3-.3-.4c-.4-.5-.5-1.2-.2-1.8,0,0,.1-.2.2,0,.2.3.2.7.3,1.1.1.3.4.8.5.8.2,0,0-.8-.1-1.2-.2-.5-.2-1,0-1.5.4.2.3.8.5,1.2,0,0,.1.2.2.2,0,0,.1,0,.2,0,.1,0,0-.8-.2-1.1s-.3-.8,0-1.1c.2.2.2.5.3.7s.4.6.5.6c0,0,0-.2,0-.3-.2-.3-.2-.6-.2-.9,0-.2.1-.4.3-.4v.8c0,0,0,.2,0,.3s0,.2.2.2c0,0,.2-.4.1-.6s-.1-.4-.2-.6c0-.3.1-.7.4-.9,0,.3,0,.6,0,.9,0,0,.1,0,.2,0s0-.1,0-.2c0-.3.1-.5.3-.8,0-.1.1-.2.2-.3s.2-.1.4,0c0,.1,0,.2,0,.3,0,.1-.2.2-.2.3,0,.1,0,.3,0,.4,0,0,0,.1,0,.2,0,.3-.4.4-.5.6,0,0,0,.2.2.2s.2,0,.3,0,.2.2,0,.2c0,0,0,0-.1,0-.3,0-.7,0-.8,0,0,0,0,.2,0,.3s.2.1.2.1c.2,0,.5.2.7.3,0,0,0,0,0,0,0,0,0,0,0,.1s0,0-.1,0c-.4,0-1.3,0-1.3,0,0,.1,1,.2,1.1.2,0,0,0,.2-.1.2s-.2.1-.3.2c-.4,0-.9,0-.9.1,0,0,.2.3.4.4.3.2,1.2,0,1.1.3-.2.5-1.1.5-1.7.5,0,0-.3,0-.4,0s.2.2.3.3c.2.2.5.2.8.2.1,0,.3,0,.4,0s.5.1.4.2c-.3.3-1.3.1-2,0,0,0,0,0-.1,0,0,.1,0,.3.2.4.3.2.7.2,1,.2s1.3-.2,1.4,0c0,0,0,.3-.5.5-.4.2-1,.2-1.6.2-.1,0-.2,0-.4,0-.3,0-.6-.2-.8,0-.1.6.7.5,1.1.5.6,0,1.9-.3,2.1-.3.2,0-.1.4-.2.4-.1.2-.3.2-.4.3-.4.2-.8.1-1.2.1-.5,0-1,0-1.5,0,0,0,0,0-.1,0-.1,0-.1.2,0,.3.2.4.9.3,1.3.3.4,0,.8,0,1.1,0,.1,0,.9-.2.7.1,0,.1-.1.2-.2.3-.6.4-.6.5-1.1.5-.4,0-.8,0-1.2,0-.2,0-.4,0-.6-.1s-.3-.2-.5-.2c-.2,0,0,.2,0,.3.1.2.3.2.6.2.3,0,.6,0,.9,0,.4,0,.8.2,1.2.2.3,0,.2.3,0,.4-.2,0-.3,0-.5,0-.5,0-.9,0-1.4,0,0,0-.1,0-.2,0-.2,0-.3,0-.5-.1-.1,0-.6-.5-.7-.3-.1.2.2.5.3.6.2.2.4.3.7.3.4,0,.8,0,1.2,0,0,0,.1,0,.2,0s0,0,0,.1c0,.2-.2.3-.4.3-.4.2-.9.1-1.3-.1,0,0-.2-.1-.3-.2-.2,0-.9-.1-.8.2,0,0,0,0,.1.1.4.3.9.4,1.4.4.2,0,.5,0,.5.2,0,.1,0,.2-.2.3s-.3,0-.4,0c-.3,0-.6,0-.9-.1-.2,0-.3,0-.5,0,0,0-.3,0-.3,0,0,0,0,.1,0,.2,0,.1.1.2.2.3,0,0,0,0,.1.1,0,0,.1.2,0,.2,0,0-.1,0-.2,0,0,0-.1,0-.2,0-.1,0-.2-.1-.3-.2-.2-.1-.4,0-.6,0-.2,0-.5,0-.7,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.8,67.6s0,0,0,0c0,0,0-.1,0-.1,0,0-.1,0-.2,0s0,0,0,0c0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.1,0-.2-.1,0,0,0-.1-.1-.1,0,0-.2,0-.3,0,0,0,0,0,0,0,0,0-.3-.2-.4-.2-.1,0-.3-.2-.4-.3,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0h0c0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.2,0,0,0,0,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2.1-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0-.2-.1-.3,0,0,0-.1-.1-.2,0,0,0,0-.1-.1,0,0-.2-.1-.3-.2-.1-.1-.3-.1-.4-.2-.2-.1-.4-.2-.6-.3-.2,0-.4-.3-.6-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2,0-.3,0,0,0-.1,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0,0,0,0,0-.1,0h0c-.2,0-.4,0-.6-.1,0,0-.1,0-.2-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0-.3,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.2,0-.2,0,0,0,0,0-.1,0-.1,0-.2,0-.3,0,0,0-.3,0-.3,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.2,0-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.1,0-.1,0,0,0,0,0,0,0,0,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0-.2,0-.3,0-.1,0-.3,0-.4,0-.2,0-.3,0-.5,0-.1,0-.3,0-.4,0,0,0,0,0,0,0-.2,0-.4.1-.6.2,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.2,0,0,0,0,0-.1,0,0,0,0,0-.1,0-.2.1-.4.6-.5.9,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1h0c0,0,0,.2.1.2,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,.1,0,.1,0,.1,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,0,0,.1s0,.1,0,.2c0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,.1,0,.1,0h0s0,0,0,0c0,0,.3,0,.3-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,0,0,0-.1,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,.2,0,.2h0c0,.1,0,.2,0,.2,0,0,0,0,0,0,0,0,0,.2,0,.2h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,.1,0,.1h0s0,0,0,0c0,0,0,0,0,.1h0c0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,.1h0s0,.2,0,.2h0s0,0,0,.1c0,0,0,0,0,0s0,0,0,.1c0,0,0,0,0,.1s0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,.2,0,.2h0s0,.3,0,.3c0,.1,0,.2,0,.3,0,.1,0,.3,0,.4,0,0,0,0,0,0,0,0,0,0,0,.1s0,.1,0,.1c0,0,0,.1,0,.2,0,.2,0,.2,0,.4,0,0,0,.2,0,.3,0,0,0,0,0,0h0c0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0c0,0,.2,0,.2,0,0,0,0,0,0,0h0s.1,0,.1,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,.1-.1,0-.2,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0-.1,0-.1,0,0,0,0,0,0,0,0,0-.2,0-.3,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0-.1-.1,0,0,0-.2,0-.3,0-.2,0-.3,0-.6,0,0,0,0,0,0,0-.1.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s.1,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0-.1,0,0,0,0,0,0h0s0,0,0,0h0c0-.1,0-.2,0-.2h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,.1,0,.2h0s0,.1,0,.2c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,.1,0,.1h0s0,0,0,0c0,0,0,.2,0,.2,0,0,0,0,0,0h0c0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.3,0,.5,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,0,0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,.1,0,.1,0,0,0,0,0,.1,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,.1,0h0s0,0,0,0h0c0,0,.1,0,.2,0,.1,0,.2,0,.3,0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0-.2.1-.3,0-.1.1-.3,0-.4,0,0,0,0,0-.1,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.1,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,0,0-.1,0,0,0,0-.1,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0-.2,0-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1-.2-.2-.2,0,0-.1,0,0-.2,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0-.1,0-.2h0s0,0,0,0,0,0,0-.1c0,0,0,0,0-.1h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.1s0,0,0,0h0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0-.1,0-.1h0s0,0,0,0c0,0,0,0,0,0h0c0-.1.1-.2.1-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0-.1,0,0,0,0,0,0h0s0,0,0-.1c0,0,0,0,0,0,0,0,0-.2.1-.2,0,0,0,0,0,0,0,0,0,0,0,0h0c.1,0,0-.1,0-.1,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0-.1-.1,0,0-.1-.1-.1-.2,0-.1,0-.2,0-.4,0-.1,0-.2,0-.3h0c0,0,.2,0,.2.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.1,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h.2c0,.1,0,.1,0,.1h.1c0,0,0,0,0,0,0,0,0,0,0,0,.4.2.7.3,1,.4,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,.1,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,.1,0,.2,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0h0c0,0,0,0,0,0,0,0,0,0,.1,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0v.6c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,.1,0,.2,0,.4h0s0,0,0,0h0s0,.1,0,.1h0c0,0,0,.1,0,.1s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0c0,.2,0,.3,0,.3,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,.1,0,.2v.3c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1h0s0,.1,0,.1c0,0,0,0,0,0,0,0,0,.1,0,.2h0s0,.2,0,.2c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,.3,0,.5,0,.8,0,.1,0,.3-.1.4h-.1c0,0,0,.1,0,.1,0,0,0,0,0,0,0,0-.2,0-.2,0,0,0-.1,0-.2,0h0s-.1,0-.1,0h0s0,0,0,0c0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.1,0s0,0,0,0c0,0-.2,0-.2,0,0,0-.1.1,0,.2,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,0,.2,0,.2,0,0,.2,0,.2,0,0,0,.2,0,.3,0,0,0,0,0,.2,0h.2s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,.1,0c0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0s0,0,.1,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c.1,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.1-.1,0,0,0-.1,0-.2,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0-.1c0-.1,0-.4,0-.6,0,0,0-.2,0-.2,0,0,0,0,0,0v-.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2,0-.2,0-.2,0-.3,0-.5,0-.1,0-.1.2,0h0c.2,0,.4.1.5.2.3,0,.8.2.8.6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,.1c0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1.1,0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.1-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,.1,0h0s0,0,0,0,0,0,0,0c0,0,0,.2-.1.2-.1.3.2.2.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.1,0,0,.2-.2.3-.3,0,0,.2-.3.2-.4,0,0,0,0,0,0,.2-.2.6-.7.6-1.1,0,0,0-.2,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.6,85.5c-.2-.6-.5-.4-1.1-1.3-.9-1.3-.9-3-.9-4.6,0-.7-.1-2,.4-2.2.5-.2,1.8-.6,2.3-.5s.7.3.9.9c.1.3.1.6.1.9,0,1.9.1,4.3-.2,5.2-.3.8-1.1.8-1.2,1.6,0,.4,0,3.1-.1,3.1s0-2.5-.3-3.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "33 89 32.9 89 32.5 88.8 32.5 88.7 32.2 88.6 32.1 88.4 32 88.3 31.6 88.1 31.4 88.1 31.1 87.8 31.1 87.7 31 87.6 30.9 87.5 30.8 87.4 30.5 87.1 30.4 87 30.2 86.9 30.2 86.6 30.1 86.5 30 86.1 30 86 29.9 85.7 30 85.6 29.9 85.3 30 85 30.2 84.9 30.2 84.8 30.1 84.5 30.2 84.3 30.2 84.1 30.3 83.8 30.3 83.7 30.3 83.4 30.3 83 30.2 82.9 30.1 82.7 30.1 82.6 29.9 82.3 29.9 81.8 29.9 81.7 29.9 81.4 29.8 81.2 29.6 80.9 29.6 80.6 29.7 80.5 29.9 80.2 30.2 80.4 30.1 80.7 30.1 80.9 30.2 81.1 30.2 81.3 30.3 81.5 30.2 81.8 30.4 82.2 30.5 82.4 30.5 82.6 30.6 82.7 30.6 82.9 30.8 83.3 30.8 83.7 30.6 84 30.5 84.1 30.4 84.4 30.4 84.5 30.4 84.7 30.5 85 30.5 85.2 30.3 85.3 30.4 85.6 30.3 85.7 30.4 85.8 30.5 86 30.5 86.4 30.6 86.6 30.6 86.6 30.5 86.8 30.8 86.9 30.9 87.1 31.2 87.2 31.2 87.4 31.3 87.3 31.5 87.6 31.7 87.7 31.8 87.8 32.1 88 32.3 88 32.5 88.3 32.6 88.4 32.7 88.4 33 88.5 33.3 88.5 33.4 88.2 33.6 88.3 33.7 88.1 33.8 87.8 34.1 87.6 34.1 87.6 34.3 87.1 34.6 87 34.7 86.9 34.9 86.6 34.9 86.2 34.9 86 34.9 85.8 34.8 85.5 34.8 85.4 34.8 85.2 34.8 85 34.8 84.8 34.7 84.6 34.6 84.4 34.5 84.2 34.6 83.7 34.6 83.6 34.5 83.3 34.6 83.2 34.6 83.1 34.7 82.9 34.7 82.7 34.7 82.5 34.7 82.3 34.8 82.1 34.7 81.9 34.8 81.7 34.9 81.4 34.9 81.3 34.8 81.2 34.8 80.9 34.9 80.6 34.9 80.5 34.9 80.4 34.9 80.1 34.8 79.9 34.7 79.8 34.8 79.5 35.1 79.7 35.2 79.8 35.2 80.1 35.2 80.2 35.4 80.5 35.2 80.8 35.2 80.9 35.3 81 35.2 81.3 35.2 81.6 35.2 81.7 35.1 81.9 35.1 82.2 35 82.3 35.1 82.6 35 82.7 35 82.9 34.9 83.1 35.1 83.3 35 83.5 35 83.6 35 83.7 35 84 35 84.2 35.1 84.5 35.2 84.8 35.2 84.9 35.1 85.1 35.3 85.3 35.2 85.6 35.3 85.8 35.3 85.9 35.2 86.2 35.3 86.6 34.9 87.1 34.7 87.3 34.6 87.5 34.4 87.7 34.3 87.9 34 88.1 34 88.2 33.9 88.6 33.6 88.8 33.4 88.7 33 89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,79.4c-1,0-2.1.1-3.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.7,79.2c-1,0-1.9,0-2.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,79.2c.4,0,.8-.5,1.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,79.6c.4,0,.8,0,1.3-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.1,80.3h1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,80.8c.5,0,.9,0,1.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,81.4h.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,81.8h.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,82.5c.2,0,.4-.1.7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,83h.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.2,83.5c.2,0,.4,0,.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.1,83.9c.2.1.5.2.8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,84.1c.5.4,1,.7,1.5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,84.4c.5.5,1.1,1,1.7,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,84.7c.4.4.9.8,1.2,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.1,85c.4.2.8.5,1,.9,0,.1,0,.3.2.4s.2.2.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,85.2c.2,0,.5.4.6.6.1.1.2.3.3.4.1.2.2.4.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,85.7c.4.4.6,1,1,1.4,0,.1.2.2.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,78.7c.2,0,.4,0,.6,0,.2,0,.4-.2.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,74.4c.5.4.6,1.1.9,1.6.4.6.8.9.9,1.6,0,.1,0,.2,0,.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,78.5c-.3-.6-1.1-2-1.3-2.6-.1-.3-.1-.6-.2-.9,0-.2,0-.5-.3-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,78.4c0-.4-.2-1.5-.3-1.8-.2-.5-.3-.9-.4-1.4,0-.3,0-.5-.2-.8,0-.1-.1-.2-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.6,77.6c0-.3,0-.6-.1-.9-.1-.6-.2-1.3-.3-1.9,0-.3-.1-.7-.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.3,77.7c-.5-.8-.9-1.6-1.3-2.4-.2-.3-.4-.7-.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,77.4h0c0,0-.2-.2-.2-.3-.2-.5-.3-.9-.4-1.4,0-.2,0-.3-.2-.5-.2-.4-.3-.8-.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.4,77.7v-1.4c0-.5-.3-.8-.4-1.3,0-.4-.2-.7-.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,77c0,0,0,.1,0,.2,0-.2,0-.4,0-.6,0-.7-.1-1.4-.1-2.1s0-.8,0-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.1,77.5c0-.9.2-1.7.2-2.6,0-.3,0-.6,0-.9s0-.2,0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.6,78.1c0-.4.1-1.3.2-1.6.2-.5.3-1.1.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,77.5c0-.5.4-1,.6-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.6,78.3c0-.6.7-1.8,1.1-2.3.2-.3.5-.6.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,77.7c.3-.4.7-.9,1-1.3.1-.2.3-.4.4-.5.1,0,.2-.2.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,78.1c0-.4.2-1.6.3-2,0-.2.2-.6.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,75.3v1.8c0-.6.2-1.1.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,77.4c0-.5-.1-1-.4-1.4,0-.2-.2-.3-.2-.5,0-.1,0-.3,0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,77.8c-.1,0-.3-.3-.4-.4s-.2-.3-.3-.5c0-.2-.1-.4-.2-.5-.2-.4-.7-.7-1.1-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,78c0-.2-.5-.9-.6-1.1,0,0,0-.1,0-.2s0-.2,0-.2c0,0,0,0,0-.1,0,0,0-.1,0-.2,0-.2,0-.3-.1-.5,0-.2,0-.4,0-.6s0-.4,0-.5c0-.1,0-.3,0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,74.1c0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0,.1,0,.2.1.3,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,.1,0,.3,0,.4,0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,.3.1.6.2.9,0,0,0,.2,0,.2,0,0,0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,77.7s-.1-.2-.1-.2c.2.4,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.3s0-.2,0-.3c0,0,0-.1,0-.2,0,0,0-.2,0-.3,0-.1,0-.2,0-.4s0-.2-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,78c0,0-.1,0-.2-.1,0,0-.1,0-.2-.1,0,0-.1-.1-.2-.2,0,0-.1-.2-.2-.2-.1-.2-.3-.4-.4-.6,0,0-.1-.2-.2-.3-.1-.1-.3-.2-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,78c0-.2-.2-.4-.2-.5s-.2-.4-.3-.6c-.1-.3-.3-.6-.5-.9-.2-.2-.4-.5-.5-.7,0,0-.1-.2-.2-.2,0,0,0,0,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,77.9c0,0,0-.1-.1-.2,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0-.1-.1-.2-.2,0,0,0,0-.1-.1,0,0-.1-.2-.2-.2,0,0,0-.1-.1-.2,0,0,0-.2-.1-.3,0-.2,0-.3-.1-.5,0-.1-.1-.2-.2-.3,0,0-.2-.2-.3-.2,0,0,0,0-.1,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.3,78.2s0,0,0,0c0,0,0,0,0,0-.2-.2-.3-.4-.5-.6-.1-.2-.2-.4-.3-.6s-.2-.4-.3-.6c0-.2-.1-.4-.2-.6,0,0,0-.2,0-.2,0-.2,0-.4-.1-.6,0-.2,0-.4,0-.6,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,77.5c0,0-.1-.1-.2-.2,0,0-.2-.1-.2-.2-.2-.3-.2-.6-.3-.8,0-.1,0-.3,0-.4,0-.1-.1-.3-.2-.4,0-.3-.2-.5-.3-.8,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0-.1-.2,0,0,0,0,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.8,77.3c-.1-.2-.3-.3-.4-.5,0,0,0-.1,0-.2,0,0,0,0,0-.2,0,0,0-.2,0-.2,0-.2,0-.4,0-.5,0-.2,0-.4,0-.6,0,0,0-.2,0-.2,0-.1,0-.2-.1-.4,0-.2-.1-.4-.2-.6,0,0,0-.1-.1-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,73.9c0,.2,0,.3,0,.5,0,.1,0,.2,0,.3,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,.2,0,.2,0,.1,0,.2,0,.3,0,.2,0,.3,0,.5,0,.2,0,.4,0,.5,0,.2,0,.3,0,.4,0,0,0,0,0,.1,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,74.3v.6c0,.1,0,.3,0,.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,.2,0,.5-.1.7,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2s0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,75c0,.3,0,.6-.1.8,0,.1,0,.3-.1.4,0,0,0,.2,0,.3,0,.4,0,.7,0,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,75c0,.3,0,.5,0,.8,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,.1,0,.2,0,.3,0,0,0,.2,0,.3,0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,77.5c.1-.1.2-.2.4-.3.1-.1.2-.2.3-.3,0-.1.2-.2.2-.3,0,0,.1-.2.2-.2s.1-.1.2-.2c0,0,0-.1.1-.2,0,0,.1,0,.2-.2.2-.1.3-.3.4-.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73.4,15.7c0,0,0-.1-.1-.2-.2-.5,0-.9.1-1.4,0-.6,0-1-.3-1.5-.8-1.5-3.4-2.1-4.4-.5-.2.3-.5.4-.8.5-.9.2-2.1.7-2.2,1.7,0,.4,0,.9-.1,1.4-.1.4-.5.7-.7,1-.4.5-.5,1-.6,1.6,0,.5,0,1.2.3,1.6.2.3.6.4.9.6s.7.4.7.7c0,.1,0,.2,0,.3,0,.4.4.6.8.7s.7.1,1.1.2c.4.2.7.5,1.1.7.7.4,1.3.3,2,0,.5-.2,1.1-.6,1.5-1,.2-.2.4-.4.6-.6.3-.2.6-.3.9-.6.4-.6.3-1.4.1-2,0-.3-.3-.6-.3-1,0-.3.1-.5.2-.8,0-.3-.1-.6-.3-.8-.1-.2-.3-.3-.4-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.4,17.1c.3,0,.2-.5.2-.8,0-.8-.6-1.6-1.2-2.3-.3-.3-.4-.6,0-.2.4.3.7.7,1,1.1.8,1,.2,3,2,2.1.5-.2,1-.5,1.5-.4,0,0,0,.1-.1.2-.6.4-1.3.5-1.8,1-.3.4.7.3,1,.4.2,0,.4.1.2.2-.3,0-.8-.2-1.1,0,0,0,0,0,0,0,.1.1.4.1.6.2.2,0,.2.2,0,.1-.2,0-.4-.1-.5,0,0,.3.3.6.4.9,0,.2.7,1.2.1,1.1-.1,0-.2-.2-.2-.3-.2-.5-.3-1-.7-1.4,0,0-.1-.1-.2-.1,0,0,0,.1-.1.2,0,.6-.2,1.1-.4,1.7,0,0-.1.3-.2.2,0,0,0-.2,0-.2,0-.5.1-1,.2-1.4,0-.2.1-.8-.2-.7-.6.4-1.3.6-2.1.9-.2,0-1.1.3-.8,0,.6-.4,1.3-.6,2-.8.9-.3.5-.8-.1-1.1-.7-.4-1.7-.5-2.6-.9-.2-.1,0-.2.2-.2.9,0,1.8.2,2.5.5.2,0,.4.2.6.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.2,76.6c0,.5-.2,1-.3,1.5,0,0,0,0,0,0,.3,0,.2.2.3.5s0,.6.1.9c0,.6.1,1.2,0,1.7,0,.3,0,.5-.1.8,0,0,0,.2-.1.2,0,0,0,0,0,0,0,0-.1,0-.2-.1,0,0,0,0,0,0,0,0,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,.1c0,0,0,.1,0,.2,0,0,0,.1,0,.2s0,0,0,.1c0,0,.1.2,0,.3,0,.1-.1.2-.2.3-.1.1-.2.3-.2.5,0,0,0,.1,0,.2,0,0,0,0,0,0,0,.2-.3.3-.3.5,0,.2,0,.4.2.6,0,0,.2.2.3.2.1,0,.2.1.3.2,0,0,0,0,.1.1,0,0,.1,0,.2-.1,0,0,.2,0,.3,0s.2.1.3.2c.2,0,.5,0,.7.2,0,0,.1,0,.2,0,0,0,.1,0,.2,0,.1-.1.3-.2.4-.4,0,0,.1-.1.2-.2,0,0,0-.1,0-.2s0-.1,0-.2c0,0,0,0,.1-.1,0,0,0-.2,0-.3,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.2s0-.1,0-.2c0,0,0-.1,0-.2s0-.1,0-.2c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2s0,0-.1-.1c0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0-.1,0-.2,0-.4,0,0,0,0,0,0s0,0,0,0c0,0,0,0-.1.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2s0-.2,0-.2c0-.1,0-.2,0-.4,0-.4.1-.9,0-1.3-.2-.7-.2-1.5-.4-2.2,0,0,.2,0,.3,0,0,0,0,0,0,0,0,0,0,0,0-.1-.1-.4-.2-.7-.3-1.1,1.2.3,2.3.5,3.5.6,0,0,.1,0,.1,0,.6-1.4-1.6-3.6-2.9-3.9-1.8-.4-4.2.2-5.7,1.3,0,0,0,0-.1.1,0,0,0,.2,0,.2.3.6,1,.8,1.6.8s1.3,0,1.9.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.6,85.5c-.1,0-.3,0-.4,0,0,0-.1,0-.2,0-.2,0-.4,0-.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,85.6c0,.2-.2.2-.4.2s-.3,0-.5,0c-.1,0-.3,0-.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,85.7c0,.1-.3.2-.4.4,0,0,0,.2,0,.2,0,.2-.3.2-.5.3,0,0-.2,0-.2,0-.3,0-.6,0-.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,85.8c-.1,0-.2,0-.3.1s-.2.1-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.7,85.2c.2.2.3.4.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,85.4c.2,0,.4.4.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57,85.8c0,.1-.1.2-.1.3,0,0,0,0,0,0,0,.1,0,.3.2.3,0,0,0,0,.1,0,.1,0,.2,0,.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.7,85.7v.4c.1,0,.1.1.1.2,0,0,0,0,0,0s0,0,0,0,0,0,0,0c.1,0,.2,0,.3.2,0,0,0,.1.1.2,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,.1.2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,85.2c.1,0,.2.2.4.2,0-.1.1-.2.2-.2,0,0,.2,0,.3,0s0,.2,0,.3c0,0,0,0,0,0,0,0,.2.1.3.1,0,0,.2,0,.3.1.1,0,.2.2.3.3,0,0,.1.2.2.3,0,0,0,.2.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.2,85.7c0,.1.3.2.4.1,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,.1,0,.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,85.9c0,.1.1.3.2.4,0,.1.2.3.3.4,0,0,.2.1.2.2,0,0,0,.1.1.2.1.2.3.4.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.7,85.7l.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.9,85.8c.2,0,.4,0,.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.1,85.9c.2.1.4.2.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.6,85.8c.2.1.3.2.4.4,0,0,0,0,0,.1,0,0,.1,0,.2.1s.1,0,.1.1c0,0-.1.1-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.4,85.6c0,.2,0,.3.2.5,0,0,0,0,0,.2,0,0,0,0,0,0,0,0,0,0,0,0,.1.1.2.3.3.4s.3.2.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.4,86.7v.4c0,0,0,.1,0,.2,0,.3.2.4.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,87.2c.3,0,.7,0,1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,87.5c0,.2-.1.4-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.7,87.7c0,0,.1.1.1.2,0,0,0,.2,0,.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,87.4c.2.2.4.3.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.3,87.2c.2-.1.3-.2.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,87.3c.1,0,.3.1.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,85.9c0,.2,0,.5,0,.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,86.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.5,86.5c0,.2,0,.3,0,.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.6,86.5h.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.5,86.2c.1,0,.2,0,.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,85.7c0,0,.2,0,.3,0,0,0,0,0,.1-.1,0,0,0,0,0-.1,0,0-.2,0-.2,0,0,0-.2,0-.2,0-.2,0-.3,0-.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,85.9c.1,0,.3,0,.4,0,0,0,.2,0,.3,0s.2,0,.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,85.4c-.2,0-.3,0-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.6,85.9c0,0,.1-.2.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.8,85.6c.2,0,.3-.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,85.6c-.2,0-.3.2-.4.3,0,0-.2.1-.3.2-.1,0-.2.1-.3.2-.2.1-.5.1-.8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57,86.3c0,.1-.1.3-.2.3,0,0-.2,0-.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.2,86.5c0,.1,0,.3,0,.4,0,0,0,.2-.1.2,0,.1,0,.2,0,.3-.1.2-.3.3-.5.3s-.4,0-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58,86.4c0,0,.1,0,.2,0,0,0,0,0,0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.3,86.7c.1,0,.2,0,.3.1,0,0,0,0-.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,86.2s0,0-.1,0,0,0,0,0c0,0,0,0,0,0,0,0,.2.1.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,86c0,0,0,.2,0,.2s0,.2,0,.2c0,0,0,0,.1,0,.2,0,.3.1.4.2,0-.2.2-.3.3-.5,0,0,0-.1.1-.2s0-.1,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,87c0,.2-.2.3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,87.2v.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.6,87.7c-.1-.1-.2-.2-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,87.6c-.1,0-.2-.2-.3-.3,0,0,0,0,0-.1,0,0,0-.2,0-.2s.1-.1.2-.2c0,0,0-.2,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,87.4c.1,0,.3.2.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,87.3c.1,0,.3,0,.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.2,86.4c0-.2,0-.3.1-.4,0,0,0,0,0,0,0,0,0-.1,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.2,86.1c.2,0,.3.2.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,86.2c.1,0,.2-.1.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.5,86c-.2,0-.5.1-.7.1,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.2,0-.2-.1s0-.2-.2-.2c0,0-.1,0-.2,0-.1,0-.3-.1-.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.7,86.4c0,.1-.1.2-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.8,85.7c-.2,0-.4,0-.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55,85.9c-.2.2-.4.3-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.2,86l-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.8,85.7c0,0,.2,0,.3,0,.1,0,.2,0,.3,0,.1,0,.3,0,.4,0,0,0,.1,0,.2,0s.1,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,85.4c0,0,0,.1-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.3,85.5c0,.1,0,.2-.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.9,85.4c-.2,0-.4.2-.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.2,86.6c0,0-.2.2-.2.3s0,.2-.1.3c-.2,0-.5.2-.7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,86.3c-.1,0-.2.1-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.1,86.6c0,0,.2.1.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,87.1c.1,0,.3.2.4.3-.1,0-.2,0-.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.9,87.3c0,.2,0,.3.2.4s.2.2.3.4c.1.2.2.4.4.5,0,0,.2,0,.2.2,0,0-.2,0-.3,0,0,0,0,0-.1,0,0,0,0-.2-.1-.2,0,0-.2,0-.3,0,0,0,0-.1-.1-.2,0,0-.1,0-.2,0-.2,0-.2-.2-.3-.4s0-.3,0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,87.8c.1,0,.2,0,.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.2,87.8c0,.1,0,.2,0,.3s0,.2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,88.5h.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,87.3c0,.3,0,.6,0,.9,0,.2.3.4.4.6.1.2.2.4.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,88.6c.1.4.2.7.4,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.3,86c0,.3.3.5.6.5,0,0,.1,0,.2,0s.1,0,0,.1c0,0-.1,0-.2,0-.1,0-.2-.1-.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.9,85.7c-.2,0-.3.3-.5.4-.4.4-.9.5-1.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.6,85.8c-.2.2-.4.5-.4.7,0,.2,0,.4,0,.6,0,0,0,0,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.6,86.6c-.1-.3-.4-.6-.6-.7-.1,0-.3-.2-.5-.2-.2,0-.4-.1-.7-.1-.2,0-.3-.1-.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.5,86.2c0,.1,0,.3,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.4,86.8l.5.4s0,0,0,0,0,0,0,0c0,0,0,0,0,0-.1,0-.2-.1-.3-.2,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0-.1-.1-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,87.4c.2,0,.3.2.3.4,0,.1,0,.2,0,.4,0,0,0,.2,0,.3,0,.2,0,.5,0,.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,88.1c0,.2-.1.4-.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,87.9c0,.2.2.4.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.1,87.9c.2,0,.4.1.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,87.7c.2,0,.4,0,.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,87.1c0,0-.1.1,0,.2s.1.1.2.1.2,0,.2,0c0,0,0-.1-.1-.2,0,0-.2-.1-.3-.2,0,0,0,0-.1,0s0,0,0,0c0,0-.3-.1-.3-.2.1,0,.3-.1.4,0,0,0,0,0,0,0s0,0,0,0c0,0,0,.1,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58,86.7c0,0-.2,0-.2,0,0-.1,0-.3,0-.4,0,0,0,0,0,0,0,0,0-.2,0-.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.4,87.9c0-.1,0-.2-.1-.3s-.2-.1-.3-.1c0,.2,0,.4,0,.5,0,0,0,.1,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.9,87.9c0,0,0,.1,0,.2s-.1,0-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.9,88.1v.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,88.2l.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.5,88.5c0,0,.2,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.4,88.6c0,0,.1,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,87.8c0,.1.1.2.2.4,0,.1,0,.2,0,.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.6,87.7c-.2,0-.4.1-.6.3-.2.1-.4.3-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.7,88.1v-.3c0,0,.2.1.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.1,85.7c0,.2,0,.4.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.7,85.5c.1,0,.2,0,.3,0,0,0,0,0,0,0,.1.1.3.2.4.2.1,0,.2-.2.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.1,86.4c0,0,0,.1,0,.2s.1,0,.2,0c.1,0,.3.1.3.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 2.9,
    y: 37.5,
    width: 10.8,
    height: 3.3,
    rx: 1.7,
    ry: 1.7,
    transform: "translate(-28.7 24.1) rotate(-55.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.5,39.8c-.3-.3-.6-.7-.9-1,.4.2.8.4,1.1.7l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.9,38.8c-1-.2-1.4-1.3-1.9-2,.5.6,1.1,1.6,1.9,1.7v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.8,37c-.8,0-1-.9-1.4-1.2-.4-.3-.9-.3-1.3-.2-.1,0-.3,0-.4.2.2-.3.6-.2.9-.2.3,0,.6,0,.9.2.3.2.5.5.6.7.2.2.4.4.7.4v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.8,34.8c-.1-.6-.5-1.2-1.1-1.6.6.3,1.1.8,1.4,1.5h-.3q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11,34.9c-.3-2.1,1.5-1.1,1.5-2.5,0,.3,0,.6-.2.8-.4.4-1,.4-1,1,0,.2,0,.5,0,.7h-.3c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.3,35.3c.5,0,1.1,0,1.7-.2.3-.2.4-.6.6-.8-.1.2-.2.4-.3.6-.1.2-.3.4-.6.4-.4.1-.9.2-1.4.3v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12,36c.8.2,1.7.5,2.4-.2-.3.3-.7.5-1.1.6-.4,0-.9,0-1.3-.1v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.1,37.1c.8,0,1.7.1,2.2.8-.6-.5-1.4-.6-2.1-.5v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.3,37.9c.8.6,1.6,1.2,2.3,1.8-.8-.6-1.6-1.1-2.4-1.6l.2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.5,39c.2.5.5,1,.9,1.4.2.2.4.3.7.3h.8c0,0-.8,0-.8,0-.3,0-.6-.1-.8-.3-.4-.4-.8-.8-1.1-1.4h.3c0-.1,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.4,40.3c.5.5,1,1.1,1,1.8,0-.3-.3-.6-.5-.9-.2-.3-.5-.5-.8-.7l.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.1,41.2c.5.8,1,1.7,2,2-1-.1-1.7-1-2.3-1.8l.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.3,42.7c.5.1,1,.5,1.1,1-.3-.4-.7-.7-1.2-.7v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.8,43.2c-.1,1,.5,2.1,1.5,2.5-1-.3-1.8-1.3-1.8-2.5h.3s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.4,42c-1.4,0-1.7-1.7-3.3-.9,1.6-.9,1.9.6,3.3.6v.3s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.5,42.6c-.9.4-1.8.9-2.8.9.9-.2,1.8-.8,2.6-1.2v.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.4,43.4c-.4.9-1.6,1.4-1.3,2.4-.1-.2-.1-.5,0-.7.1-.7.8-1.2,1.1-1.8h.3c0,.1,0,.1,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.8,41.1c-.2,0-.4,0-.6,0-.5-.3-.5-.9-.5-1.4,0-.4,0-1-.3-1.3,0-.1-.2-.2-.4-.2.2,0,.3,0,.4.2.5.6.3,1.6.7,2.2.1.2.4.4.6.3v.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3.2,39.3c.9.2,1.9,0,2.7.4.3.1.5.3.8.5l-.2.2c-.5-.4-.9-.7-1.5-.9-.6-.1-1.2-.1-1.8-.3h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesGbe);
export default __webpack_public_path__ + "static/media/studies-GBE.18c0b9a0db4f4edb8530009c3a8e271d.svg";
export { ForwardRef as ReactComponent };